//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AgentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    register(model: AgentRegisterPostModel, cancelToken?: CancelToken): Promise<AgentRegisteredResponseModel> {
        let url_ = this.baseUrl + "/api/agents/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<AgentRegisteredResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentRegisteredResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentRegisteredResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRegisteredResponseModel>(null as any);
    }

    validateRegistrationToken(token: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/agents/validate-token?";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateRegistrationToken(_response);
        });
    }

    protected processValidateRegistrationToken(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAgents( cancelToken?: CancelToken): Promise<AgentResponseModel[]> {
        let url_ = this.baseUrl + "/api/agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgents(_response);
        });
    }

    protected processGetAgents(response: AxiosResponse): Promise<AgentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AgentResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentResponseModel[]>(null as any);
    }

    getActiveAgents( cancelToken?: CancelToken): Promise<ActiveAgentResponseModel[]> {
        let url_ = this.baseUrl + "/api/active-agents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveAgents(_response);
        });
    }

    protected processGetActiveAgents(response: AxiosResponse): Promise<ActiveAgentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveAgentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActiveAgentResponseModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveAgentResponseModel[]>(null as any);
    }
}

export class DispatcherClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    createAgentAccessToken(model: AgentAuthorizePostModel, cancelToken?: CancelToken): Promise<AgentAccessTokenResponseModel> {
        let url_ = this.baseUrl + "/api/dispatcher/authorize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAgentAccessToken(_response);
        });
    }

    protected processCreateAgentAccessToken(response: AxiosResponse): Promise<AgentAccessTokenResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentAccessTokenResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentAccessTokenResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentAccessTokenResponseModel>(null as any);
    }

    getAgentSettings( cancelToken?: CancelToken): Promise<AgentGeneralSettingsResponseModel> {
        let url_ = this.baseUrl + "/api/dispatcher/agent/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgentSettings(_response);
        });
    }

    protected processGetAgentSettings(response: AxiosResponse): Promise<AgentGeneralSettingsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentGeneralSettingsResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentGeneralSettingsResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentGeneralSettingsResponseModel>(null as any);
    }

    getJob(uniqueJobId: string | null, cancelToken?: CancelToken): Promise<JobForAgentResponseModel> {
        let url_ = this.baseUrl + "/api/dispatcher/jobs/{uniqueJobId}";
        if (uniqueJobId === undefined || uniqueJobId === null)
            throw new Error("The parameter 'uniqueJobId' must be defined.");
        url_ = url_.replace("{uniqueJobId}", encodeURIComponent("" + uniqueJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: AxiosResponse): Promise<JobForAgentResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobForAgentResponseModel.fromJS(resultData200);
            return Promise.resolve<JobForAgentResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobForAgentResponseModel>(null as any);
    }

    getFlowsheetForJob(uniqueJobId: string | null, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/dispatcher/jobs/{uniqueJobId}/flowsheet";
        if (uniqueJobId === undefined || uniqueJobId === null)
            throw new Error("The parameter 'uniqueJobId' must be defined.");
        url_ = url_.replace("{uniqueJobId}", encodeURIComponent("" + uniqueJobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlowsheetForJob(_response);
        });
    }

    protected processGetFlowsheetForJob(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class HomeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    home( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHome(_response);
        });
    }

    protected processHome(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class JobsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    createJob(model: NewJobPostModel, cancelToken?: CancelToken): Promise<JobAcceptedResponseModel> {
        let url_ = this.baseUrl + "/api/jobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJob(_response);
        });
    }

    protected processCreateJob(response: AxiosResponse): Promise<JobAcceptedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobAcceptedResponseModel.fromJS(resultData200);
            return Promise.resolve<JobAcceptedResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobAcceptedResponseModel>(null as any);
    }

    createJobFromFilter(model: NewJobFromFilterPostModel, cancelToken?: CancelToken): Promise<JobAcceptedResponseModel> {
        let url_ = this.baseUrl + "/api/jobs/from-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobFromFilter(_response);
        });
    }

    protected processCreateJobFromFilter(response: AxiosResponse): Promise<JobAcceptedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobAcceptedResponseModel.fromJS(resultData200);
            return Promise.resolve<JobAcceptedResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobAcceptedResponseModel>(null as any);
    }
}

export class ServiceInformationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getBuildDate( cancelToken?: CancelToken): Promise<ServiceInformationModel> {
        let url_ = this.baseUrl + "/api/serviceInformation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBuildDate(_response);
        });
    }

    protected processGetBuildDate(response: AxiosResponse): Promise<ServiceInformationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceInformationModel.fromJS(resultData200);
            return Promise.resolve<ServiceInformationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceInformationModel>(null as any);
    }
}

export class ActiveJobsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getActiveJobs( cancelToken?: CancelToken): Promise<ActiveJobResponseModel[]> {
        let url_ = this.baseUrl + "/api/jobs/active-jobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveJobs(_response);
        });
    }

    protected processGetActiveJobs(response: AxiosResponse): Promise<ActiveJobResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveJobResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActiveJobResponseModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveJobResponseModel[]>(null as any);
    }
}

export class AgentGroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getAgentGroups( cancelToken?: CancelToken): Promise<AgentGroupResponseModel[]> {
        let url_ = this.baseUrl + "/api/agent/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgentGroups(_response);
        });
    }

    protected processGetAgentGroups(response: AxiosResponse): Promise<AgentGroupResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentGroupResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AgentGroupResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentGroupResponseModel[]>(null as any);
    }

    createAgentGroup(model: AgentGroupPostModel, cancelToken?: CancelToken): Promise<AgentGroupResponseModel> {
        let url_ = this.baseUrl + "/api/agent/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAgentGroup(_response);
        });
    }

    protected processCreateAgentGroup(response: AxiosResponse): Promise<AgentGroupResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentGroupResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentGroupResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentGroupResponseModel>(null as any);
    }

    getAgentGroup(id: number, cancelToken?: CancelToken): Promise<AgentGroupResponseModel> {
        let url_ = this.baseUrl + "/api/agents/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgentGroup(_response);
        });
    }

    protected processGetAgentGroup(response: AxiosResponse): Promise<AgentGroupResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentGroupResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentGroupResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentGroupResponseModel>(null as any);
    }

    updateAgentGroup(id: number | null, model: AgentGroupPostModel, cancelToken?: CancelToken): Promise<AgentGroupResponseModel> {
        let url_ = this.baseUrl + "/api/agent/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAgentGroup(_response);
        });
    }

    protected processUpdateAgentGroup(response: AxiosResponse): Promise<AgentGroupResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentGroupResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentGroupResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentGroupResponseModel>(null as any);
    }

    getDefaultAgentRegistrationToken( cancelToken?: CancelToken): Promise<AgentRegistrationTokenResponseModel> {
        let url_ = this.baseUrl + "/api/agent-groups/default/registration-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultAgentRegistrationToken(_response);
        });
    }

    protected processGetDefaultAgentRegistrationToken(response: AxiosResponse): Promise<AgentRegistrationTokenResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentRegistrationTokenResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentRegistrationTokenResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRegistrationTokenResponseModel>(null as any);
    }
}

export class AgentRegistrationTokensClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getAgentRegistrationTokens(id: number, cancelToken?: CancelToken): Promise<AgentRegistrationTokenResponseModel[]> {
        let url_ = this.baseUrl + "/api/agents/groups/{id}/registration-tokens";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgentRegistrationTokens(_response);
        });
    }

    protected processGetAgentRegistrationTokens(response: AxiosResponse): Promise<AgentRegistrationTokenResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentRegistrationTokenResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AgentRegistrationTokenResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRegistrationTokenResponseModel[]>(null as any);
    }

    createToken(id: number, cancelToken?: CancelToken): Promise<AgentRegistrationTokenResponseModel> {
        let url_ = this.baseUrl + "/api/agents/groups/{id}/registration-tokens";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateToken(_response);
        });
    }

    protected processCreateToken(response: AxiosResponse): Promise<AgentRegistrationTokenResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgentRegistrationTokenResponseModel.fromJS(resultData200);
            return Promise.resolve<AgentRegistrationTokenResponseModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgentRegistrationTokenResponseModel>(null as any);
    }

    deactivateToken(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/agents/groups/{id}/registration-tokens";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateToken(_response);
        });
    }

    protected processDeactivateToken(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationApiKeyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getApplicationApiKeys(applicationId: number, cancelToken?: CancelToken): Promise<ApplicationApiKeyResponseModel[]> {
        let url_ = this.baseUrl + "/api/applicationapikey/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationApiKeys(_response);
        });
    }

    protected processGetApplicationApiKeys(response: AxiosResponse): Promise<ApplicationApiKeyResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationApiKeyResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApplicationApiKeyResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationApiKeyResponseModel[]>(null as any);
    }

    createApiKey(applicationId: number, model: CreateApplicationKeyPostModel, cancelToken?: CancelToken): Promise<ApplicationApiKeyResponseModel> {
        let url_ = this.baseUrl + "/api/applicationapikey/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApiKey(_response);
        });
    }

    protected processCreateApiKey(response: AxiosResponse): Promise<ApplicationApiKeyResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationApiKeyResponseModel.fromJS(resultData200);
            return Promise.resolve<ApplicationApiKeyResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationApiKeyResponseModel>(null as any);
    }

    deactivateApiKey(applicationId: number, apiKeyId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/applicationapikey/{applicationId}/deactivate/{apiKeyId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (apiKeyId === undefined || apiKeyId === null)
            throw new Error("The parameter 'apiKeyId' must be defined.");
        url_ = url_.replace("{apiKeyId}", encodeURIComponent("" + apiKeyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivateApiKey(_response);
        });
    }

    protected processDeactivateApiKey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getApplications( cancelToken?: CancelToken): Promise<ApplicationResponseModel[]> {
        let url_ = this.baseUrl + "/api/applications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplications(_response);
        });
    }

    protected processGetApplications(response: AxiosResponse): Promise<ApplicationResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApplicationResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationResponseModel[]>(null as any);
    }

    create(model: ApplicationPostModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/applications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getApplication(id: number, cancelToken?: CancelToken): Promise<ApplicationResponseModel> {
        let url_ = this.baseUrl + "/api/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplication(_response);
        });
    }

    protected processGetApplication(response: AxiosResponse): Promise<ApplicationResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationResponseModel.fromJS(resultData200);
            return Promise.resolve<ApplicationResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationResponseModel>(null as any);
    }

    update(id: number | null, model: ApplicationPostModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteApplication(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteApplication(_response);
        });
    }

    protected processDeleteApplication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDefaultApplication( cancelToken?: CancelToken): Promise<ApplicationResponseModel> {
        let url_ = this.baseUrl + "/api/applications/default-application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultApplication(_response);
        });
    }

    protected processGetDefaultApplication(response: AxiosResponse): Promise<ApplicationResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationResponseModel.fromJS(resultData200);
            return Promise.resolve<ApplicationResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationResponseModel>(null as any);
    }

    editDefaultApplication(model: EditDefaultApplicationPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/default-application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditDefaultApplication(_response);
        });
    }

    protected processEditDefaultApplication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    generateDefaultApplicationApiKey( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/applications/default-application/generate-new-api-key";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateDefaultApplicationApiKey(_response);
        });
    }

    protected processGenerateDefaultApplicationApiKey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createOnBehalf(model: ApplicationPostModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/applications/create-on-behalf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOnBehalf(_response);
        });
    }

    protected processCreateOnBehalf(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ErrorResponseModel.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getActiveApiKey(applicationId: number, cancelToken?: CancelToken): Promise<ActiveApiKeyResponseModel> {
        let url_ = this.baseUrl + "/api/dispatcher/applications/{applicationId}/active-api-key";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActiveApiKey(_response);
        });
    }

    protected processGetActiveApiKey(response: AxiosResponse): Promise<ActiveApiKeyResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActiveApiKeyResponseModel.fromJS(resultData200);
            return Promise.resolve<ActiveApiKeyResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveApiKeyResponseModel>(null as any);
    }
}

export class FlowsheetsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getFlowsheetObjects(driveId: string | null, itemId: string | null, versionId: string | null, cancelToken?: CancelToken): Promise<FlowsheetObjectsResponseModel> {
        let url_ = this.baseUrl + "/api/flowsheets/{driveId}/{itemId}/{versionId}/flowsheet-objects";
        if (driveId === undefined || driveId === null)
            throw new Error("The parameter 'driveId' must be defined.");
        url_ = url_.replace("{driveId}", encodeURIComponent("" + driveId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlowsheetObjects(_response);
        });
    }

    protected processGetFlowsheetObjects(response: AxiosResponse): Promise<FlowsheetObjectsResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FlowsheetObjectsResponseModel.fromJS(resultData200);
            return Promise.resolve<FlowsheetObjectsResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlowsheetObjectsResponseModel>(null as any);
    }

    getFlowsheetComponents(itemId: string | null, versionId: string | null, cancelToken?: CancelToken): Promise<FlowsheetObjectModel[]> {
        let url_ = this.baseUrl + "/api/flowsheets/{itemId}/{versionId}/flowsheet-components";
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlowsheetComponents(_response);
        });
    }

    protected processGetFlowsheetComponents(response: AxiosResponse): Promise<FlowsheetObjectModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlowsheetObjectModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FlowsheetObjectModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlowsheetObjectModel[]>(null as any);
    }

    isFlowsheetAnalyzed(driveId: string | null, itemId: string | null, versionId: string | null, cancelToken?: CancelToken): Promise<IsFlowsheetAnalyzedResponseModel> {
        let url_ = this.baseUrl + "/api/flowsheets/{driveId}/{itemId}/{versionId}/is-analyzed";
        if (driveId === undefined || driveId === null)
            throw new Error("The parameter 'driveId' must be defined.");
        url_ = url_.replace("{driveId}", encodeURIComponent("" + driveId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIsFlowsheetAnalyzed(_response);
        });
    }

    protected processIsFlowsheetAnalyzed(response: AxiosResponse): Promise<IsFlowsheetAnalyzedResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IsFlowsheetAnalyzedResponseModel.fromJS(resultData200);
            return Promise.resolve<IsFlowsheetAnalyzedResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IsFlowsheetAnalyzedResponseModel>(null as any);
    }
}

export class JobActionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getJobActions(jobId: number, cancelToken?: CancelToken): Promise<JobActionResponseModel[]> {
        let url_ = this.baseUrl + "/api/ui/jobactions/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobActions(_response);
        });
    }

    protected processGetJobActions(response: AxiosResponse): Promise<JobActionResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobActionResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JobActionResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobActionResponseModel[]>(null as any);
    }

    getWebHookAction(actionId: number, cancelToken?: CancelToken): Promise<WebHookActionResponseModel> {
        let url_ = this.baseUrl + "/api/ui/jobactions/{actionId}/webhook";
        if (actionId === undefined || actionId === null)
            throw new Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWebHookAction(_response);
        });
    }

    protected processGetWebHookAction(response: AxiosResponse): Promise<WebHookActionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WebHookActionResponseModel.fromJS(resultData200);
            return Promise.resolve<WebHookActionResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WebHookActionResponseModel>(null as any);
    }

    getEmailAction(actionId: number, cancelToken?: CancelToken): Promise<EmailActionResponseModel> {
        let url_ = this.baseUrl + "/api/ui/jobactions/{actionId}/email";
        if (actionId === undefined || actionId === null)
            throw new Error("The parameter 'actionId' must be defined.");
        url_ = url_.replace("{actionId}", encodeURIComponent("" + actionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmailAction(_response);
        });
    }

    protected processGetEmailAction(response: AxiosResponse): Promise<EmailActionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmailActionResponseModel.fromJS(resultData200);
            return Promise.resolve<EmailActionResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailActionResponseModel>(null as any);
    }
}

export class JobDetailsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getJob(jobId: number, cancelToken?: CancelToken): Promise<JobResponseModel> {
        let url_ = this.baseUrl + "/api/ui/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: AxiosResponse): Promise<JobResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobResponseModel.fromJS(resultData200);
            return Promise.resolve<JobResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobResponseModel>(null as any);
    }

    getExecutions(jobId: number, skip: number | undefined, take: number | undefined, cancelToken?: CancelToken): Promise<PagedListResponseModelOfJobExecutionResponseModel> {
        let url_ = this.baseUrl + "/api/ui/jobs/{jobId}/executions?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "Skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "Take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExecutions(_response);
        });
    }

    protected processGetExecutions(response: AxiosResponse): Promise<PagedListResponseModelOfJobExecutionResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedListResponseModelOfJobExecutionResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedListResponseModelOfJobExecutionResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListResponseModelOfJobExecutionResponseModel>(null as any);
    }

    getExecutionResults(executionId: number, cancelToken?: CancelToken): Promise<JobExecutionResultResponseModel[]> {
        let url_ = this.baseUrl + "/api/ui/jobs/executions/{executionId}/results";
        if (executionId === undefined || executionId === null)
            throw new Error("The parameter 'executionId' must be defined.");
        url_ = url_.replace("{executionId}", encodeURIComponent("" + executionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExecutionResults(_response);
        });
    }

    protected processGetExecutionResults(response: AxiosResponse): Promise<JobExecutionResultResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobExecutionResultResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JobExecutionResultResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobExecutionResultResponseModel[]>(null as any);
    }

    downloadCalculatedFlowsheet(executionId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ui/jobs/executions/{executionId}/calculated-flowsheet";
        if (executionId === undefined || executionId === null)
            throw new Error("The parameter 'executionId' must be defined.");
        url_ = url_.replace("{executionId}", encodeURIComponent("" + executionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadCalculatedFlowsheet(_response);
        });
    }

    protected processDownloadCalculatedFlowsheet(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ErrorResponseModel.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ErrorResponseModel.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cancelJob(jobId: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ui/jobs/{jobId}/cancel";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelJob(_response);
        });
    }

    protected processCancelJob(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class JobExecutionActionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getJobExecutionActions(jobExecutionId: number, cancelToken?: CancelToken): Promise<JobExecutionActionResponseModel[]> {
        let url_ = this.baseUrl + "/api/ui/jobexecutionactions/{jobExecutionId}";
        if (jobExecutionId === undefined || jobExecutionId === null)
            throw new Error("The parameter 'jobExecutionId' must be defined.");
        url_ = url_.replace("{jobExecutionId}", encodeURIComponent("" + jobExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobExecutionActions(_response);
        });
    }

    protected processGetJobExecutionActions(response: AxiosResponse): Promise<JobExecutionActionResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobExecutionActionResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JobExecutionActionResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobExecutionActionResponseModel[]>(null as any);
    }
}

export class SearchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getUserJobs(userQuery: UserJobsQuery, cancelToken?: CancelToken): Promise<PagedListResponseModelOfJobSearchResponseModel> {
        let url_ = this.baseUrl + "/api/ui/search/user-jobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userQuery);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserJobs(_response);
        });
    }

    protected processGetUserJobs(response: AxiosResponse): Promise<PagedListResponseModelOfJobSearchResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedListResponseModelOfJobSearchResponseModel.fromJS(resultData200);
            return Promise.resolve<PagedListResponseModelOfJobSearchResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedListResponseModelOfJobSearchResponseModel>(null as any);
    }

    getUserJobSimulators( cancelToken?: CancelToken): Promise<SimulatorType[]> {
        let url_ = this.baseUrl + "/api/ui/search/user-job-simulators";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserJobSimulators(_response);
        });
    }

    protected processGetUserJobSimulators(response: AxiosResponse): Promise<SimulatorType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SimulatorType[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SimulatorType[]>(null as any);
    }

    reindexDetectionsInElasticsearch( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindexDetectionsInElasticsearch(_response);
        });
    }

    protected processReindexDetectionsInElasticsearch(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getReindexRequests( cancelToken?: CancelToken): Promise<ReindexingRunModel[]> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex-requests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReindexRequests(_response);
        });
    }

    protected processGetReindexRequests(response: AxiosResponse): Promise<ReindexingRunModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReindexingRunModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ReindexingRunModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReindexingRunModel[]>(null as any);
    }

    getReindexRequest(requestId: string, cancelToken?: CancelToken): Promise<ReindexingRunModel> {
        let url_ = this.baseUrl + "/api/elasticsearch/reindex-requests/{requestId}";
        if (requestId === undefined || requestId === null)
            throw new Error("The parameter 'requestId' must be defined.");
        url_ = url_.replace("{requestId}", encodeURIComponent("" + requestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReindexRequest(_response);
        });
    }

    protected processGetReindexRequest(response: AxiosResponse): Promise<ReindexingRunModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReindexingRunModel.fromJS(resultData200);
            return Promise.resolve<ReindexingRunModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReindexingRunModel>(null as any);
    }

    reindex( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ui/search/reindex";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReindex(_response);
        });
    }

    protected processReindex(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SharingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getAgentGroupSharedWith(agentGroupId: number, cancelToken?: CancelToken): Promise<SharedWithResponseModel[]> {
        let url_ = this.baseUrl + "/api/ui/agent-groups/{agentGroupId}/shared-with";
        if (agentGroupId === undefined || agentGroupId === null)
            throw new Error("The parameter 'agentGroupId' must be defined.");
        url_ = url_.replace("{agentGroupId}", encodeURIComponent("" + agentGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgentGroupSharedWith(_response);
        });
    }

    protected processGetAgentGroupSharedWith(response: AxiosResponse): Promise<SharedWithResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SharedWithResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SharedWithResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedWithResponseModel[]>(null as any);
    }

    shareAgentGroup(agentGroupId: number, models: ShareWithPostModel[], cancelToken?: CancelToken): Promise<SharedWithResponseModel[]> {
        let url_ = this.baseUrl + "/api/ui/agent-groups/{agentGroupId}/shared-with";
        if (agentGroupId === undefined || agentGroupId === null)
            throw new Error("The parameter 'agentGroupId' must be defined.");
        url_ = url_.replace("{agentGroupId}", encodeURIComponent("" + agentGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShareAgentGroup(_response);
        });
    }

    protected processShareAgentGroup(response: AxiosResponse): Promise<SharedWithResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SharedWithResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SharedWithResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SharedWithResponseModel[]>(null as any);
    }

    stopSharing(agentGroupId: number, model: StopSharingPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/ui/agent-groups/{agentGroupId}/shared-with";
        if (agentGroupId === undefined || agentGroupId === null)
            throw new Error("The parameter 'agentGroupId' must be defined.");
        url_ = url_.replace("{agentGroupId}", encodeURIComponent("" + agentGroupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopSharing(_response);
        });
    }

    protected processStopSharing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getStatisticsForAgent(agentId: number, cancelToken?: CancelToken): Promise<AggregatedUsegDataResponseModel> {
        let url_ = this.baseUrl + "/api/statistics/agents/{agentId}/overall";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsForAgent(_response);
        });
    }

    protected processGetStatisticsForAgent(response: AxiosResponse): Promise<AggregatedUsegDataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedUsegDataResponseModel.fromJS(resultData200);
            return Promise.resolve<AggregatedUsegDataResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedUsegDataResponseModel>(null as any);
    }

    getStatisticsForApplication(applicationId: number, cancelToken?: CancelToken): Promise<AggregatedUsegDataResponseModel> {
        let url_ = this.baseUrl + "/api/statistics/applications/{applicationId}/overall";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsForApplication(_response);
        });
    }

    protected processGetStatisticsForApplication(response: AxiosResponse): Promise<AggregatedUsegDataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedUsegDataResponseModel.fromJS(resultData200);
            return Promise.resolve<AggregatedUsegDataResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedUsegDataResponseModel>(null as any);
    }

    getStatisticsForFlowsheet(flowsheetId: string | null, cancelToken?: CancelToken): Promise<AggregatedUsegDataResponseModel> {
        let url_ = this.baseUrl + "/api/statistics/flowsheets/{flowsheetId}/overall";
        if (flowsheetId === undefined || flowsheetId === null)
            throw new Error("The parameter 'flowsheetId' must be defined.");
        url_ = url_.replace("{flowsheetId}", encodeURIComponent("" + flowsheetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsForFlowsheet(_response);
        });
    }

    protected processGetStatisticsForFlowsheet(response: AxiosResponse): Promise<AggregatedUsegDataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedUsegDataResponseModel.fromJS(resultData200);
            return Promise.resolve<AggregatedUsegDataResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedUsegDataResponseModel>(null as any);
    }

    getStatisticsForFlowsheet2(flowsheetId: string | null, flowsheetVersion: string | null, cancelToken?: CancelToken): Promise<AggregatedUsegDataResponseModel> {
        let url_ = this.baseUrl + "/api/statistics/flowsheets/{flowsheetId}/verions/{flowsheetVersion}/overall";
        if (flowsheetId === undefined || flowsheetId === null)
            throw new Error("The parameter 'flowsheetId' must be defined.");
        url_ = url_.replace("{flowsheetId}", encodeURIComponent("" + flowsheetId));
        if (flowsheetVersion === undefined || flowsheetVersion === null)
            throw new Error("The parameter 'flowsheetVersion' must be defined.");
        url_ = url_.replace("{flowsheetVersion}", encodeURIComponent("" + flowsheetVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsForFlowsheet2(_response);
        });
    }

    protected processGetStatisticsForFlowsheet2(response: AxiosResponse): Promise<AggregatedUsegDataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedUsegDataResponseModel.fromJS(resultData200);
            return Promise.resolve<AggregatedUsegDataResponseModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedUsegDataResponseModel>(null as any);
    }

    getStatisticsForTag(tag: string | null, cancelToken?: CancelToken): Promise<AggregatedUsegDataResponseModel> {
        let url_ = this.baseUrl + "/api/statistics/tags/{tag}/overall";
        if (tag === undefined || tag === null)
            throw new Error("The parameter 'tag' must be defined.");
        url_ = url_.replace("{tag}", encodeURIComponent("" + tag));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatisticsForTag(_response);
        });
    }

    protected processGetStatisticsForTag(response: AxiosResponse): Promise<AggregatedUsegDataResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AggregatedUsegDataResponseModel.fromJS(resultData200);
            return Promise.resolve<AggregatedUsegDataResponseModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AggregatedUsegDataResponseModel>(null as any);
    }

    recalculateStatisticsByTag(tagName: string | null, userId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/statistics/tags/{tagName}/recalculate?";
        if (tagName === undefined || tagName === null)
            throw new Error("The parameter 'tagName' must be defined.");
        url_ = url_.replace("{tagName}", encodeURIComponent("" + tagName));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRecalculateStatisticsByTag(_response);
        });
    }

    protected processRecalculateStatisticsByTag(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TestClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    updateJobInElasticSearch( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/test/elastic";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobInElasticSearch(_response);
        });
    }

    protected processUpdateJobInElasticSearch(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserGroupsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getUserOrgGroup( cancelToken?: CancelToken): Promise<UserGroupResponseModel> {
        let url_ = this.baseUrl + "/api/user/group";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOrgGroup(_response);
        });
    }

    protected processGetUserOrgGroup(response: AxiosResponse): Promise<UserGroupResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserGroupResponseModel.fromJS(resultData200);
            return Promise.resolve<UserGroupResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserGroupResponseModel>(null as any);
    }
}

export class ExternalClientsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getJobResult(jobId: number, cancelToken?: CancelToken): Promise<ExternalClientResultResponseModel> {
        let url_ = this.baseUrl + "/api/external-clients/jobs/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobResult(_response);
        });
    }

    protected processGetJobResult(response: AxiosResponse): Promise<ExternalClientResultResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalClientResultResponseModel.fromJS(resultData200);
            return Promise.resolve<ExternalClientResultResponseModel>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ErrorResponseModel.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalClientResultResponseModel>(null as any);
    }
}

export class JobFilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    uploadFile(jobExecutionId: number, flowsheet: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dispatcher/jobs/{jobExecutionId}/results/flowsheet";
        if (jobExecutionId === undefined || jobExecutionId === null)
            throw new Error("The parameter 'jobExecutionId' must be defined.");
        url_ = url_.replace("{jobExecutionId}", encodeURIComponent("" + jobExecutionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (flowsheet !== null && flowsheet !== undefined)
            content_.append("Flowsheet", flowsheet.data, flowsheet.fileName ? flowsheet.fileName : "Flowsheet");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ResultsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    postAnalyzeFlowsheetResults(activeJobId: string | null, model: AnalyzedFlowsheetPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dispatcher/jobs/{activeJobId}/results/analyze-flowsheet";
        if (activeJobId === undefined || activeJobId === null)
            throw new Error("The parameter 'activeJobId' must be defined.");
        url_ = url_.replace("{activeJobId}", encodeURIComponent("" + activeJobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAnalyzeFlowsheetResults(_response);
        });
    }

    protected processPostAnalyzeFlowsheetResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    postCalculateFlowsheetResults(activeJobId: string | null, model: CalcualtedFlowsheetPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dispatcher/jobs/{activeJobId}/results/calculate-flowsheet";
        if (activeJobId === undefined || activeJobId === null)
            throw new Error("The parameter 'activeJobId' must be defined.");
        url_ = url_.replace("{activeJobId}", encodeURIComponent("" + activeJobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCalculateFlowsheetResults(_response);
        });
    }

    protected processPostCalculateFlowsheetResults(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    failed(activeJobId: string | null, model: FailedJobPostModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/dispatcher/jobs/{activeJobId}/results/failed";
        if (activeJobId === undefined || activeJobId === null)
            throw new Error("The parameter 'activeJobId' must be defined.");
        url_ = url_.replace("{activeJobId}", encodeURIComponent("" + activeJobId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFailed(_response);
        });
    }

    protected processFailed(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AgentSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getChemcad7Settings( cancelToken?: CancelToken): Promise<Chemcad7SettingsModel> {
        let url_ = this.baseUrl + "/api/agents-management/settings/chemcad7";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChemcad7Settings(_response);
        });
    }

    protected processGetChemcad7Settings(response: AxiosResponse): Promise<Chemcad7SettingsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Chemcad7SettingsModel.fromJS(resultData200);
            return Promise.resolve<Chemcad7SettingsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Chemcad7SettingsModel>(null as any);
    }
}

export class UserAgentsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:7471";

    }

    getUserAgents(userId: string | null, cancelToken?: CancelToken): Promise<ActiveAgentResponseModel[]> {
        let url_ = this.baseUrl + "/api/admin/user-agents/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAgents(_response);
        });
    }

    protected processGetUserAgents(response: AxiosResponse): Promise<ActiveAgentResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveAgentResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ActiveAgentResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveAgentResponseModel[]>(null as any);
    }

    getUserAgentsList( cancelToken?: CancelToken): Promise<UserAgentsResponseModel[]> {
        let url_ = this.baseUrl + "/api/admin/user-agents/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserAgentsList(_response);
        });
    }

    protected processGetUserAgentsList(response: AxiosResponse): Promise<UserAgentsResponseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAgentsResponseModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserAgentsResponseModel[]>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ErrorResponseModel.fromJS(resultData500);
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserAgentsResponseModel[]>(null as any);
    }
}

export class AgentRegisteredResponseModel implements IAgentRegisteredResponseModel {
    uniqueRegistrationId?: string;
    installationVerificationToken?: string;

    constructor(data?: IAgentRegisteredResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueRegistrationId = _data["uniqueRegistrationId"];
            this.installationVerificationToken = _data["installationVerificationToken"];
        }
    }

    static fromJS(data: any): AgentRegisteredResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegisteredResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueRegistrationId"] = this.uniqueRegistrationId;
        data["installationVerificationToken"] = this.installationVerificationToken;
        return data;
    }
}

export interface IAgentRegisteredResponseModel {
    uniqueRegistrationId?: string;
    installationVerificationToken?: string;
}

export class ErrorResponseModel implements IErrorResponseModel {
    code?: string | undefined;
    error?: string | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IErrorResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.error = _data["error"];
            if (_data["validationErrors"]) {
                this.validationErrors = {} as any;
                for (let key in _data["validationErrors"]) {
                    if (_data["validationErrors"].hasOwnProperty(key))
                        (<any>this.validationErrors)![key] = _data["validationErrors"][key] !== undefined ? _data["validationErrors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ErrorResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["error"] = this.error;
        if (this.validationErrors) {
            data["validationErrors"] = {};
            for (let key in this.validationErrors) {
                if (this.validationErrors.hasOwnProperty(key))
                    (<any>data["validationErrors"])[key] = (<any>this.validationErrors)[key];
            }
        }
        return data;
    }
}

export interface IErrorResponseModel {
    code?: string | undefined;
    error?: string | undefined;
    validationErrors?: { [key: string]: string[]; } | undefined;
}

export class AgentRegisterPostModel implements IAgentRegisterPostModel {
    registrationToken!: string;
    displayName!: string;
    machineName?: string | undefined;

    constructor(data?: IAgentRegisterPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registrationToken = _data["registrationToken"];
            this.displayName = _data["displayName"];
            this.machineName = _data["machineName"];
        }
    }

    static fromJS(data: any): AgentRegisterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegisterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationToken"] = this.registrationToken;
        data["displayName"] = this.displayName;
        data["machineName"] = this.machineName;
        return data;
    }
}

export interface IAgentRegisterPostModel {
    registrationToken: string;
    displayName: string;
    machineName?: string | undefined;
}

export class AgentAccessTokenResponseModel implements IAgentAccessTokenResponseModel {
    accessToken?: string | undefined;
    validForSeconds?: number;

    constructor(data?: IAgentAccessTokenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.validForSeconds = _data["validForSeconds"];
        }
    }

    static fromJS(data: any): AgentAccessTokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAccessTokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["validForSeconds"] = this.validForSeconds;
        return data;
    }
}

export interface IAgentAccessTokenResponseModel {
    accessToken?: string | undefined;
    validForSeconds?: number;
}

export class AgentAuthorizePostModel implements IAgentAuthorizePostModel {
    uniqueRegistrationId!: string;
    installationVerificationToken!: string;

    constructor(data?: IAgentAuthorizePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueRegistrationId = _data["uniqueRegistrationId"];
            this.installationVerificationToken = _data["installationVerificationToken"];
        }
    }

    static fromJS(data: any): AgentAuthorizePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentAuthorizePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueRegistrationId"] = this.uniqueRegistrationId;
        data["installationVerificationToken"] = this.installationVerificationToken;
        return data;
    }
}

export interface IAgentAuthorizePostModel {
    uniqueRegistrationId: string;
    installationVerificationToken: string;
}

export class AgentGeneralSettingsResponseModel implements IAgentGeneralSettingsResponseModel {
    runAllJobs?: boolean;
    disableIfHostIsBusy?: boolean;

    constructor(data?: IAgentGeneralSettingsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.runAllJobs = _data["runAllJobs"];
            this.disableIfHostIsBusy = _data["disableIfHostIsBusy"];
        }
    }

    static fromJS(data: any): AgentGeneralSettingsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentGeneralSettingsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["runAllJobs"] = this.runAllJobs;
        data["disableIfHostIsBusy"] = this.disableIfHostIsBusy;
        return data;
    }
}

export interface IAgentGeneralSettingsResponseModel {
    runAllJobs?: boolean;
    disableIfHostIsBusy?: boolean;
}

export class JobForAgentResponseModel implements IJobForAgentResponseModel {
    activeJobId?: string;
    jobExecutionId?: number;
    flowsheetUniqueId?: string | undefined;
    jobType?: JobType;
    simulatorType?: SimulatorType;
    stepEvaluationFunction?: string | undefined;
    inputParameters?: InputParameterModel[] | undefined;
    outputParameters?: OutputParameterModel[] | undefined;
    flowsheetTimeout?: string;
    uploadCalculatedFlowsheet?: boolean;
    jobOwnerUsername?: string | undefined;

    constructor(data?: IJobForAgentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeJobId = _data["activeJobId"];
            this.jobExecutionId = _data["jobExecutionId"];
            this.flowsheetUniqueId = _data["flowsheetUniqueId"];
            this.jobType = _data["jobType"];
            this.simulatorType = _data["simulatorType"];
            this.stepEvaluationFunction = _data["stepEvaluationFunction"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(InputParameterModel.fromJS(item));
            }
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterModel.fromJS(item));
            }
            this.flowsheetTimeout = _data["flowsheetTimeout"];
            this.uploadCalculatedFlowsheet = _data["uploadCalculatedFlowsheet"];
            this.jobOwnerUsername = _data["jobOwnerUsername"];
        }
    }

    static fromJS(data: any): JobForAgentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobForAgentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeJobId"] = this.activeJobId;
        data["jobExecutionId"] = this.jobExecutionId;
        data["flowsheetUniqueId"] = this.flowsheetUniqueId;
        data["jobType"] = this.jobType;
        data["simulatorType"] = this.simulatorType;
        data["stepEvaluationFunction"] = this.stepEvaluationFunction;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        data["flowsheetTimeout"] = this.flowsheetTimeout;
        data["uploadCalculatedFlowsheet"] = this.uploadCalculatedFlowsheet;
        data["jobOwnerUsername"] = this.jobOwnerUsername;
        return data;
    }
}

export interface IJobForAgentResponseModel {
    activeJobId?: string;
    jobExecutionId?: number;
    flowsheetUniqueId?: string | undefined;
    jobType?: JobType;
    simulatorType?: SimulatorType;
    stepEvaluationFunction?: string | undefined;
    inputParameters?: InputParameterModel[] | undefined;
    outputParameters?: OutputParameterModel[] | undefined;
    flowsheetTimeout?: string;
    uploadCalculatedFlowsheet?: boolean;
    jobOwnerUsername?: string | undefined;
}

export enum JobType {
    RunFlowsheet = 1,
    AnalyzeFlowsheet = 2,
    RunFlowsheetStepByStep = 3,
}

export enum SimulatorType {
    Chemcad7 = 1,
    DWSIM = 2,
    Chemcad8 = 3,
}

export class InputParameterModel implements IInputParameterModel {
    parameter?: string | undefined;
    value?: number;

    constructor(data?: IInputParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InputParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new InputParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IInputParameterModel {
    parameter?: string | undefined;
    value?: number;
}

export class OutputParameterModel implements IOutputParameterModel {
    parameter?: string | undefined;

    constructor(data?: IOutputParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
        }
    }

    static fromJS(data: any): OutputParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        return data;
    }
}

export interface IOutputParameterModel {
    parameter?: string | undefined;
}

export class JobAcceptedResponseModel implements IJobAcceptedResponseModel {
    jobId?: number;
    simulator?: SimulatorType;

    constructor(data?: IJobAcceptedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.simulator = _data["simulator"];
        }
    }

    static fromJS(data: any): JobAcceptedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobAcceptedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["simulator"] = this.simulator;
        return data;
    }
}

export interface IJobAcceptedResponseModel {
    jobId?: number;
    simulator?: SimulatorType;
}

export class NewJobPostModelBase implements INewJobPostModelBase {
    actions?: ActionModel[] | undefined;
    settings?: SettingsModel | undefined;
    tags?: string[] | undefined;

    constructor(data?: INewJobPostModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(ActionModel.fromJS(item));
            }
            this.settings = _data["settings"] ? SettingsModel.fromJS(_data["settings"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): NewJobPostModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new NewJobPostModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item.toJSON());
        }
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface INewJobPostModelBase {
    actions?: ActionModel[] | undefined;
    settings?: SettingsModel | undefined;
    tags?: string[] | undefined;
}

export class NewJobPostModel extends NewJobPostModelBase implements INewJobPostModel {
    apiKey?: string | undefined;
    jobType!: JobType;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
    flowsheetFromJobId?: number | undefined;
    stepEvaluationFunction?: string | undefined;
    inputParameters?: InputParameterModel2[] | undefined;
    outputParameters?: OutputParameterModel2[] | undefined;

    constructor(data?: INewJobPostModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.jobType = _data["jobType"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.flowsheetItemId = _data["flowsheetItemId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
            this.flowsheetFromJobId = _data["flowsheetFromJobId"];
            this.stepEvaluationFunction = _data["stepEvaluationFunction"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(InputParameterModel2.fromJS(item));
            }
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NewJobPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewJobPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["jobType"] = this.jobType;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["flowsheetItemId"] = this.flowsheetItemId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        data["flowsheetFromJobId"] = this.flowsheetFromJobId;
        data["stepEvaluationFunction"] = this.stepEvaluationFunction;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INewJobPostModel extends INewJobPostModelBase {
    apiKey?: string | undefined;
    jobType: JobType;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
    flowsheetFromJobId?: number | undefined;
    stepEvaluationFunction?: string | undefined;
    inputParameters?: InputParameterModel2[] | undefined;
    outputParameters?: OutputParameterModel2[] | undefined;
}

export class InputParameterModel2 implements IInputParameterModel2 {
    parameter!: string;
    value!: number;

    constructor(data?: IInputParameterModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InputParameterModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new InputParameterModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IInputParameterModel2 {
    parameter: string;
    value: number;
}

export class OutputParameterModel2 implements IOutputParameterModel2 {
    parameter!: string;

    constructor(data?: IOutputParameterModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
        }
    }

    static fromJS(data: any): OutputParameterModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        return data;
    }
}

export interface IOutputParameterModel2 {
    parameter: string;
}

export class ActionModel implements IActionModel {
    name?: string | undefined;
    triggerOn!: JobActionTriggerOn;
    customTriggerConditionFunction?: string | undefined;
    type!: JobActionType;
    webHook?: WebHookActionModel | undefined;
    email?: EmailActionModel | undefined;

    constructor(data?: IActionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.triggerOn = _data["triggerOn"];
            this.customTriggerConditionFunction = _data["customTriggerConditionFunction"];
            this.type = _data["type"];
            this.webHook = _data["webHook"] ? WebHookActionModel.fromJS(_data["webHook"]) : <any>undefined;
            this.email = _data["email"] ? EmailActionModel.fromJS(_data["email"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["triggerOn"] = this.triggerOn;
        data["customTriggerConditionFunction"] = this.customTriggerConditionFunction;
        data["type"] = this.type;
        data["webHook"] = this.webHook ? this.webHook.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActionModel {
    name?: string | undefined;
    triggerOn: JobActionTriggerOn;
    customTriggerConditionFunction?: string | undefined;
    type: JobActionType;
    webHook?: WebHookActionModel | undefined;
    email?: EmailActionModel | undefined;
}

export enum JobActionTriggerOn {
    Always = 1,
    OnSuccess = 2,
    OnError = 3,
    Custom = 4,
}

export enum JobActionType {
    WebHook = 1,
    Email = 2,
}

export class WebHookActionModel implements IWebHookActionModel {
    endpoint!: string;
    httpMethod!: WebHookActionHttpMethod;
    headers?: HeaderModel[] | undefined;
    payloadType!: WebHookActionPayloadType;
    formParameters?: FormParameterModel[] | undefined;
    body?: string | undefined;

    constructor(data?: IWebHookActionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.httpMethod = _data["httpMethod"];
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(HeaderModel.fromJS(item));
            }
            this.payloadType = _data["payloadType"];
            if (Array.isArray(_data["formParameters"])) {
                this.formParameters = [] as any;
                for (let item of _data["formParameters"])
                    this.formParameters!.push(FormParameterModel.fromJS(item));
            }
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): WebHookActionModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookActionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["httpMethod"] = this.httpMethod;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        data["payloadType"] = this.payloadType;
        if (Array.isArray(this.formParameters)) {
            data["formParameters"] = [];
            for (let item of this.formParameters)
                data["formParameters"].push(item.toJSON());
        }
        data["body"] = this.body;
        return data;
    }
}

export interface IWebHookActionModel {
    endpoint: string;
    httpMethod: WebHookActionHttpMethod;
    headers?: HeaderModel[] | undefined;
    payloadType: WebHookActionPayloadType;
    formParameters?: FormParameterModel[] | undefined;
    body?: string | undefined;
}

export enum WebHookActionHttpMethod {
    Get = 1,
    Post = 2,
    Patch = 3,
    Put = 4,
    Delete = 5,
}

export class HeaderModel implements IHeaderModel {
    name!: string;
    value!: string;

    constructor(data?: IHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IHeaderModel {
    name: string;
    value: string;
}

export enum WebHookActionPayloadType {
    DefaultJson = 1,
    CustomJson = 2,
    CustomFormdata = 3,
}

export class FormParameterModel implements IFormParameterModel {
    name!: string;
    value!: string;

    constructor(data?: IFormParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FormParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FormParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IFormParameterModel {
    name: string;
    value: string;
}

export class EmailActionModel extends ActionModel implements IEmailActionModel {
    to!: string;
    from!: string;
    subject!: string;
    message!: string;
    isHtml?: boolean;

    constructor(data?: IEmailActionModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.to = _data["to"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.isHtml = _data["isHtml"];
        }
    }

    static fromJS(data: any): EmailActionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailActionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["to"] = this.to;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["isHtml"] = this.isHtml;
        super.toJSON(data);
        return data;
    }
}

export interface IEmailActionModel extends IActionModel {
    to: string;
    from: string;
    subject: string;
    message: string;
    isHtml?: boolean;
}

export class SettingsModel implements ISettingsModel {
    uploadCalculatedFlowsheet?: boolean | undefined;
    retryOnTimeout?: boolean | undefined;
    timeout?: string | undefined;
    maxRetriesCount?: number | undefined;

    constructor(data?: ISettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadCalculatedFlowsheet = _data["uploadCalculatedFlowsheet"];
            this.retryOnTimeout = _data["retryOnTimeout"];
            this.timeout = _data["timeout"];
            this.maxRetriesCount = _data["maxRetriesCount"];
        }
    }

    static fromJS(data: any): SettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadCalculatedFlowsheet"] = this.uploadCalculatedFlowsheet;
        data["retryOnTimeout"] = this.retryOnTimeout;
        data["timeout"] = this.timeout;
        data["maxRetriesCount"] = this.maxRetriesCount;
        return data;
    }
}

export interface ISettingsModel {
    uploadCalculatedFlowsheet?: boolean | undefined;
    retryOnTimeout?: boolean | undefined;
    timeout?: string | undefined;
    maxRetriesCount?: number | undefined;
}

export class NewJobFromFilterPostModel extends NewJobPostModelBase implements INewJobFromFilterPostModel {
    apiKey!: string;
    filterUniqueIdentifier!: string;
    inputParameters?: InputParameterModel2[] | undefined;
    filterId?: number | undefined;
    fileUniqueIdentifier?: string | undefined;

    constructor(data?: INewJobFromFilterPostModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.apiKey = _data["apiKey"];
            this.filterUniqueIdentifier = _data["filterUniqueIdentifier"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(InputParameterModel2.fromJS(item));
            }
            this.filterId = _data["filterId"];
            this.fileUniqueIdentifier = _data["fileUniqueIdentifier"];
        }
    }

    static fromJS(data: any): NewJobFromFilterPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewJobFromFilterPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        data["filterUniqueIdentifier"] = this.filterUniqueIdentifier;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        data["filterId"] = this.filterId;
        data["fileUniqueIdentifier"] = this.fileUniqueIdentifier;
        super.toJSON(data);
        return data;
    }
}

export interface INewJobFromFilterPostModel extends INewJobPostModelBase {
    apiKey: string;
    filterUniqueIdentifier: string;
    inputParameters?: InputParameterModel2[] | undefined;
    filterId?: number | undefined;
    fileUniqueIdentifier?: string | undefined;
}

export class ServiceInformationModel implements IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;

    constructor(data?: IServiceInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildDate = _data["buildDate"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ServiceInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildDate"] = this.buildDate;
        data["version"] = this.version;
        return data;
    }
}

export interface IServiceInformationModel {
    buildDate?: string | undefined;
    version?: string | undefined;
}

export class ActiveJobResponseModel implements IActiveJobResponseModel {
    activeJobId?: string;
    job?: JobModel | undefined;
    jobExecution?: JobExecutionModel | undefined;
    createdAt?: Date;
    flowsheet?: FlowsheetModel | undefined;
    jobType?: JobType;
    application?: ApplicationModel | undefined;
    simulatorType?: SimulatorType;
    priority?: number;
    agent?: AgentModel | undefined;

    constructor(data?: IActiveJobResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeJobId = _data["activeJobId"];
            this.job = _data["job"] ? JobModel.fromJS(_data["job"]) : <any>undefined;
            this.jobExecution = _data["jobExecution"] ? JobExecutionModel.fromJS(_data["jobExecution"]) : <any>undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.flowsheet = _data["flowsheet"] ? FlowsheetModel.fromJS(_data["flowsheet"]) : <any>undefined;
            this.jobType = _data["jobType"];
            this.application = _data["application"] ? ApplicationModel.fromJS(_data["application"]) : <any>undefined;
            this.simulatorType = _data["simulatorType"];
            this.priority = _data["priority"];
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActiveJobResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveJobResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeJobId"] = this.activeJobId;
        data["job"] = this.job ? this.job.toJSON() : <any>undefined;
        data["jobExecution"] = this.jobExecution ? this.jobExecution.toJSON() : <any>undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["flowsheet"] = this.flowsheet ? this.flowsheet.toJSON() : <any>undefined;
        data["jobType"] = this.jobType;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["simulatorType"] = this.simulatorType;
        data["priority"] = this.priority;
        data["agent"] = this.agent ? this.agent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActiveJobResponseModel {
    activeJobId?: string;
    job?: JobModel | undefined;
    jobExecution?: JobExecutionModel | undefined;
    createdAt?: Date;
    flowsheet?: FlowsheetModel | undefined;
    jobType?: JobType;
    application?: ApplicationModel | undefined;
    simulatorType?: SimulatorType;
    priority?: number;
    agent?: AgentModel | undefined;
}

export class JobModel implements IJobModel {
    id?: number;
    status?: JobProcessingStatus;

    constructor(data?: IJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IJobModel {
    id?: number;
    status?: JobProcessingStatus;
}

export enum JobProcessingStatus {
    NotCalculated = 0,
    Finished = 1,
    Failed = 2,
    Cancelled = 3,
}

export class JobExecutionModel implements IJobExecutionModel {
    id?: number;
    status?: JobExecutionStatus;

    constructor(data?: IJobExecutionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobExecutionModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobExecutionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IJobExecutionModel {
    id?: number;
    status?: JobExecutionStatus;
}

export enum JobExecutionStatus {
    NotExecuted = 0,
    Calculated = 1,
    Failed = 2,
    AssignedToAgent = 3,
    Cancelled = 4,
}

export class FlowsheetModel implements IFlowsheetModel {
    name?: string | undefined;
    driveItemId?: string | undefined;
    driveItemVersion?: string | undefined;

    constructor(data?: IFlowsheetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.driveItemId = _data["driveItemId"];
            this.driveItemVersion = _data["driveItemVersion"];
        }
    }

    static fromJS(data: any): FlowsheetModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["driveItemId"] = this.driveItemId;
        data["driveItemVersion"] = this.driveItemVersion;
        return data;
    }
}

export interface IFlowsheetModel {
    name?: string | undefined;
    driveItemId?: string | undefined;
    driveItemVersion?: string | undefined;
}

export class ApplicationModel implements IApplicationModel {
    id?: number;
    name?: string | undefined;

    constructor(data?: IApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IApplicationModel {
    id?: number;
    name?: string | undefined;
}

export class AgentModel implements IAgentModel {
    id?: number;
    name?: string | undefined;
    assignedAt?: Date;

    constructor(data?: IAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.assignedAt = _data["assignedAt"] ? new Date(_data["assignedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgentModel {
    id?: number;
    name?: string | undefined;
    assignedAt?: Date;
}

export class AgentGroupResponseModel implements IAgentGroupResponseModel {
    id?: number;
    name?: string | undefined;
    agentLicenseKey?: string | undefined;
    runAllJobs?: boolean | undefined;
    saveCalculatedFlowsheets?: boolean | undefined;
    disableIfHostIsBusy?: boolean | undefined;
    licensingServers?: string[] | undefined;
    runApplications?: number[] | undefined;
    agents?: AgentResponseModel[] | undefined;

    constructor(data?: IAgentGroupResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.agentLicenseKey = _data["agentLicenseKey"];
            this.runAllJobs = _data["runAllJobs"];
            this.saveCalculatedFlowsheets = _data["saveCalculatedFlowsheets"];
            this.disableIfHostIsBusy = _data["disableIfHostIsBusy"];
            if (Array.isArray(_data["licensingServers"])) {
                this.licensingServers = [] as any;
                for (let item of _data["licensingServers"])
                    this.licensingServers!.push(item);
            }
            if (Array.isArray(_data["runApplications"])) {
                this.runApplications = [] as any;
                for (let item of _data["runApplications"])
                    this.runApplications!.push(item);
            }
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(AgentResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentGroupResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentGroupResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["agentLicenseKey"] = this.agentLicenseKey;
        data["runAllJobs"] = this.runAllJobs;
        data["saveCalculatedFlowsheets"] = this.saveCalculatedFlowsheets;
        data["disableIfHostIsBusy"] = this.disableIfHostIsBusy;
        if (Array.isArray(this.licensingServers)) {
            data["licensingServers"] = [];
            for (let item of this.licensingServers)
                data["licensingServers"].push(item);
        }
        if (Array.isArray(this.runApplications)) {
            data["runApplications"] = [];
            for (let item of this.runApplications)
                data["runApplications"].push(item);
        }
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgentGroupResponseModel {
    id?: number;
    name?: string | undefined;
    agentLicenseKey?: string | undefined;
    runAllJobs?: boolean | undefined;
    saveCalculatedFlowsheets?: boolean | undefined;
    disableIfHostIsBusy?: boolean | undefined;
    licensingServers?: string[] | undefined;
    runApplications?: number[] | undefined;
    agents?: AgentResponseModel[] | undefined;
}

export class AgentResponseModel implements IAgentResponseModel {
    id?: number;
    displayName?: string | undefined;
    agentGroupId?: number;
    agentGroupName?: string | undefined;
    createdAt?: Date;

    constructor(data?: IAgentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.agentGroupId = _data["agentGroupId"];
            this.agentGroupName = _data["agentGroupName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AgentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["agentGroupId"] = this.agentGroupId;
        data["agentGroupName"] = this.agentGroupName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAgentResponseModel {
    id?: number;
    displayName?: string | undefined;
    agentGroupId?: number;
    agentGroupName?: string | undefined;
    createdAt?: Date;
}

export class AgentGroupPostModel implements IAgentGroupPostModel {
    id?: number;
    name!: string;
    runAllJobs?: boolean | undefined;
    saveCalculatedFlowsheets?: boolean | undefined;
    disableIfHostIsBusy?: boolean | undefined;
    licensingServers?: string[] | undefined;
    runApplications?: number[] | undefined;

    constructor(data?: IAgentGroupPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.runAllJobs = _data["runAllJobs"];
            this.saveCalculatedFlowsheets = _data["saveCalculatedFlowsheets"];
            this.disableIfHostIsBusy = _data["disableIfHostIsBusy"];
            if (Array.isArray(_data["licensingServers"])) {
                this.licensingServers = [] as any;
                for (let item of _data["licensingServers"])
                    this.licensingServers!.push(item);
            }
            if (Array.isArray(_data["runApplications"])) {
                this.runApplications = [] as any;
                for (let item of _data["runApplications"])
                    this.runApplications!.push(item);
            }
        }
    }

    static fromJS(data: any): AgentGroupPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentGroupPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["runAllJobs"] = this.runAllJobs;
        data["saveCalculatedFlowsheets"] = this.saveCalculatedFlowsheets;
        data["disableIfHostIsBusy"] = this.disableIfHostIsBusy;
        if (Array.isArray(this.licensingServers)) {
            data["licensingServers"] = [];
            for (let item of this.licensingServers)
                data["licensingServers"].push(item);
        }
        if (Array.isArray(this.runApplications)) {
            data["runApplications"] = [];
            for (let item of this.runApplications)
                data["runApplications"].push(item);
        }
        return data;
    }
}

export interface IAgentGroupPostModel {
    id?: number;
    name: string;
    runAllJobs?: boolean | undefined;
    saveCalculatedFlowsheets?: boolean | undefined;
    disableIfHostIsBusy?: boolean | undefined;
    licensingServers?: string[] | undefined;
    runApplications?: number[] | undefined;
}

export class AgentRegistrationTokenResponseModel implements IAgentRegistrationTokenResponseModel {
    id?: number;
    token?: string;
    createdAt?: Date;
    isActive?: boolean;

    constructor(data?: IAgentRegistrationTokenResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AgentRegistrationTokenResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentRegistrationTokenResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IAgentRegistrationTokenResponseModel {
    id?: number;
    token?: string;
    createdAt?: Date;
    isActive?: boolean;
}

export class ActiveAgentResponseModel implements IActiveAgentResponseModel {
    agentId?: number;
    displayName?: string | undefined;
    instanceNumber?: number;
    buildVersion?: string | undefined;
    currentJob?: CurrentJobModel | undefined;
    status?: StatusModel | undefined;
    lastUpdateAt?: Date;
    simulators?: SimulatorModel[] | undefined;
    owner?: OwnerModel | undefined;
    isShared?: boolean;

    constructor(data?: IActiveAgentResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agentId = _data["agentId"];
            this.displayName = _data["displayName"];
            this.instanceNumber = _data["instanceNumber"];
            this.buildVersion = _data["buildVersion"];
            this.currentJob = _data["currentJob"] ? CurrentJobModel.fromJS(_data["currentJob"]) : <any>undefined;
            this.status = _data["status"] ? StatusModel.fromJS(_data["status"]) : <any>undefined;
            this.lastUpdateAt = _data["lastUpdateAt"] ? new Date(_data["lastUpdateAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["simulators"])) {
                this.simulators = [] as any;
                for (let item of _data["simulators"])
                    this.simulators!.push(SimulatorModel.fromJS(item));
            }
            this.owner = _data["owner"] ? OwnerModel.fromJS(_data["owner"]) : <any>undefined;
            this.isShared = _data["isShared"];
        }
    }

    static fromJS(data: any): ActiveAgentResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAgentResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agentId"] = this.agentId;
        data["displayName"] = this.displayName;
        data["instanceNumber"] = this.instanceNumber;
        data["buildVersion"] = this.buildVersion;
        data["currentJob"] = this.currentJob ? this.currentJob.toJSON() : <any>undefined;
        data["status"] = this.status ? this.status.toJSON() : <any>undefined;
        data["lastUpdateAt"] = this.lastUpdateAt ? this.lastUpdateAt.toISOString() : <any>undefined;
        if (Array.isArray(this.simulators)) {
            data["simulators"] = [];
            for (let item of this.simulators)
                data["simulators"].push(item.toJSON());
        }
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["isShared"] = this.isShared;
        return data;
    }
}

export interface IActiveAgentResponseModel {
    agentId?: number;
    displayName?: string | undefined;
    instanceNumber?: number;
    buildVersion?: string | undefined;
    currentJob?: CurrentJobModel | undefined;
    status?: StatusModel | undefined;
    lastUpdateAt?: Date;
    simulators?: SimulatorModel[] | undefined;
    owner?: OwnerModel | undefined;
    isShared?: boolean;
}

export class CurrentJobModel implements ICurrentJobModel {
    jobId?: number;
    jobExecutionId?: number;
    assignedAt?: Date;
    owner?: OwnerModel | undefined;

    constructor(data?: ICurrentJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobExecutionId = _data["jobExecutionId"];
            this.assignedAt = _data["assignedAt"] ? new Date(_data["assignedAt"].toString()) : <any>undefined;
            this.owner = _data["owner"] ? OwnerModel.fromJS(_data["owner"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentJobModel {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentJobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobExecutionId"] = this.jobExecutionId;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurrentJobModel {
    jobId?: number;
    jobExecutionId?: number;
    assignedAt?: Date;
    owner?: OwnerModel | undefined;
}

export class OwnerModel implements IOwnerModel {
    id?: string | undefined;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;

    constructor(data?: IOwnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.userPrincipalName = _data["userPrincipalName"];
        }
    }

    static fromJS(data: any): OwnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["userPrincipalName"] = this.userPrincipalName;
        return data;
    }
}

export interface IOwnerModel {
    id?: string | undefined;
    displayName?: string | undefined;
    userPrincipalName?: string | undefined;
}

export class StatusModel implements IStatusModel {
    isReadyForCalculation?: boolean;
    code?: string | undefined;
    title?: string | undefined;

    constructor(data?: IStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReadyForCalculation = _data["isReadyForCalculation"];
            this.code = _data["code"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): StatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new StatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReadyForCalculation"] = this.isReadyForCalculation;
        data["code"] = this.code;
        data["title"] = this.title;
        return data;
    }
}

export interface IStatusModel {
    isReadyForCalculation?: boolean;
    code?: string | undefined;
    title?: string | undefined;
}

export class SimulatorModel implements ISimulatorModel {
    type?: SimulatorType;
    version?: string | undefined;

    constructor(data?: ISimulatorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): SimulatorModel {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["version"] = this.version;
        return data;
    }
}

export interface ISimulatorModel {
    type?: SimulatorType;
    version?: string | undefined;
}

export class ApplicationApiKeyResponseModel implements IApplicationApiKeyResponseModel {
    id?: number;
    applicationId?: number;
    apiKey?: string;
    description?: string | undefined;
    isActive?: boolean;
    createdAt?: Date;

    constructor(data?: IApplicationApiKeyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.apiKey = _data["apiKey"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationApiKeyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationApiKeyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["apiKey"] = this.apiKey;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicationApiKeyResponseModel {
    id?: number;
    applicationId?: number;
    apiKey?: string;
    description?: string | undefined;
    isActive?: boolean;
    createdAt?: Date;
}

export class CreateApplicationKeyPostModel implements ICreateApplicationKeyPostModel {
    description!: string;

    constructor(data?: ICreateApplicationKeyPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateApplicationKeyPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApplicationKeyPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateApplicationKeyPostModel {
    description: string;
}

export class ApplicationResponseModel implements IApplicationResponseModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    priority?: number | undefined;
    createdAt?: Date;
    saveCalculatedFlowsheets?: boolean;
    canRunOnAllAgents?: boolean | undefined;
    requiredAgentVersionMin?: string | undefined;
    requiredAgentVersionMax?: string | undefined;
    defaultFlowsheetTimeout?: string | undefined;
    applicationApiKey?: string | undefined;
    retriesCount?: number | undefined;
    agentsItCanRunOn?: AgentResponseModel[] | undefined;
    isDeleted?: boolean;

    constructor(data?: IApplicationResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.priority = _data["priority"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.saveCalculatedFlowsheets = _data["saveCalculatedFlowsheets"];
            this.canRunOnAllAgents = _data["canRunOnAllAgents"];
            this.requiredAgentVersionMin = _data["requiredAgentVersionMin"];
            this.requiredAgentVersionMax = _data["requiredAgentVersionMax"];
            this.defaultFlowsheetTimeout = _data["defaultFlowsheetTimeout"];
            this.applicationApiKey = _data["applicationApiKey"];
            this.retriesCount = _data["retriesCount"];
            if (Array.isArray(_data["agentsItCanRunOn"])) {
                this.agentsItCanRunOn = [] as any;
                for (let item of _data["agentsItCanRunOn"])
                    this.agentsItCanRunOn!.push(AgentResponseModel.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ApplicationResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["priority"] = this.priority;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["saveCalculatedFlowsheets"] = this.saveCalculatedFlowsheets;
        data["canRunOnAllAgents"] = this.canRunOnAllAgents;
        data["requiredAgentVersionMin"] = this.requiredAgentVersionMin;
        data["requiredAgentVersionMax"] = this.requiredAgentVersionMax;
        data["defaultFlowsheetTimeout"] = this.defaultFlowsheetTimeout;
        data["applicationApiKey"] = this.applicationApiKey;
        data["retriesCount"] = this.retriesCount;
        if (Array.isArray(this.agentsItCanRunOn)) {
            data["agentsItCanRunOn"] = [];
            for (let item of this.agentsItCanRunOn)
                data["agentsItCanRunOn"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IApplicationResponseModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    priority?: number | undefined;
    createdAt?: Date;
    saveCalculatedFlowsheets?: boolean;
    canRunOnAllAgents?: boolean | undefined;
    requiredAgentVersionMin?: string | undefined;
    requiredAgentVersionMax?: string | undefined;
    defaultFlowsheetTimeout?: string | undefined;
    applicationApiKey?: string | undefined;
    retriesCount?: number | undefined;
    agentsItCanRunOn?: AgentResponseModel[] | undefined;
    isDeleted?: boolean;
}

export class EditDefaultApplicationPostModel implements IEditDefaultApplicationPostModel {
    saveCalculatedFlowsheets?: boolean;
    defaultFlowsheetTimeout?: string | undefined;
    retriesCount?: number | undefined;

    constructor(data?: IEditDefaultApplicationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.saveCalculatedFlowsheets = _data["saveCalculatedFlowsheets"];
            this.defaultFlowsheetTimeout = _data["defaultFlowsheetTimeout"];
            this.retriesCount = _data["retriesCount"];
        }
    }

    static fromJS(data: any): EditDefaultApplicationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new EditDefaultApplicationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["saveCalculatedFlowsheets"] = this.saveCalculatedFlowsheets;
        data["defaultFlowsheetTimeout"] = this.defaultFlowsheetTimeout;
        data["retriesCount"] = this.retriesCount;
        return data;
    }
}

export interface IEditDefaultApplicationPostModel {
    saveCalculatedFlowsheets?: boolean;
    defaultFlowsheetTimeout?: string | undefined;
    retriesCount?: number | undefined;
}

export class ApplicationPostModel implements IApplicationPostModel {
    id?: number;
    name!: string;
    description?: string | undefined;
    priority?: number | undefined;
    saveCalculatedFlowsheets?: boolean;
    canRunOnAllAgents?: boolean | undefined;
    requiredAgentVersionMin?: string | undefined;
    requiredAgentVersionMax?: string | undefined;
    defaultFlowsheetTimeout?: string | undefined;
    retriesCount?: number | undefined;
    agentsItCanRunOn?: number[] | undefined;

    constructor(data?: IApplicationPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.priority = _data["priority"];
            this.saveCalculatedFlowsheets = _data["saveCalculatedFlowsheets"];
            this.canRunOnAllAgents = _data["canRunOnAllAgents"];
            this.requiredAgentVersionMin = _data["requiredAgentVersionMin"];
            this.requiredAgentVersionMax = _data["requiredAgentVersionMax"];
            this.defaultFlowsheetTimeout = _data["defaultFlowsheetTimeout"];
            this.retriesCount = _data["retriesCount"];
            if (Array.isArray(_data["agentsItCanRunOn"])) {
                this.agentsItCanRunOn = [] as any;
                for (let item of _data["agentsItCanRunOn"])
                    this.agentsItCanRunOn!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["priority"] = this.priority;
        data["saveCalculatedFlowsheets"] = this.saveCalculatedFlowsheets;
        data["canRunOnAllAgents"] = this.canRunOnAllAgents;
        data["requiredAgentVersionMin"] = this.requiredAgentVersionMin;
        data["requiredAgentVersionMax"] = this.requiredAgentVersionMax;
        data["defaultFlowsheetTimeout"] = this.defaultFlowsheetTimeout;
        data["retriesCount"] = this.retriesCount;
        if (Array.isArray(this.agentsItCanRunOn)) {
            data["agentsItCanRunOn"] = [];
            for (let item of this.agentsItCanRunOn)
                data["agentsItCanRunOn"].push(item);
        }
        return data;
    }
}

export interface IApplicationPostModel {
    id?: number;
    name: string;
    description?: string | undefined;
    priority?: number | undefined;
    saveCalculatedFlowsheets?: boolean;
    canRunOnAllAgents?: boolean | undefined;
    requiredAgentVersionMin?: string | undefined;
    requiredAgentVersionMax?: string | undefined;
    defaultFlowsheetTimeout?: string | undefined;
    retriesCount?: number | undefined;
    agentsItCanRunOn?: number[] | undefined;
}

export class FlowsheetObjectsResponseModel implements IFlowsheetObjectsResponseModel {
    flowsheetObjects?: FlowsheetObjectModel[] | undefined;
    flowsheetParameters?: FlowsheetParameterModel[] | undefined;

    constructor(data?: IFlowsheetObjectsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["flowsheetObjects"])) {
                this.flowsheetObjects = [] as any;
                for (let item of _data["flowsheetObjects"])
                    this.flowsheetObjects!.push(FlowsheetObjectModel.fromJS(item));
            }
            if (Array.isArray(_data["flowsheetParameters"])) {
                this.flowsheetParameters = [] as any;
                for (let item of _data["flowsheetParameters"])
                    this.flowsheetParameters!.push(FlowsheetParameterModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlowsheetObjectsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetObjectsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.flowsheetObjects)) {
            data["flowsheetObjects"] = [];
            for (let item of this.flowsheetObjects)
                data["flowsheetObjects"].push(item.toJSON());
        }
        if (Array.isArray(this.flowsheetParameters)) {
            data["flowsheetParameters"] = [];
            for (let item of this.flowsheetParameters)
                data["flowsheetParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlowsheetObjectsResponseModel {
    flowsheetObjects?: FlowsheetObjectModel[] | undefined;
    flowsheetParameters?: FlowsheetParameterModel[] | undefined;
}

export class FlowsheetObjectModel implements IFlowsheetObjectModel {
    uniqueIdentifier?: string | undefined;
    displayName?: string | undefined;
    objectType?: FlowsheetObjectType;
    subtype?: string | undefined;
    casNumber?: string | undefined;

    constructor(data?: IFlowsheetObjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.displayName = _data["displayName"];
            this.objectType = _data["objectType"];
            this.subtype = _data["subtype"];
            this.casNumber = _data["casNumber"];
        }
    }

    static fromJS(data: any): FlowsheetObjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetObjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["displayName"] = this.displayName;
        data["objectType"] = this.objectType;
        data["subtype"] = this.subtype;
        data["casNumber"] = this.casNumber;
        return data;
    }
}

export interface IFlowsheetObjectModel {
    uniqueIdentifier?: string | undefined;
    displayName?: string | undefined;
    objectType?: FlowsheetObjectType;
    subtype?: string | undefined;
    casNumber?: string | undefined;
}

export enum FlowsheetObjectType {
    UnitOp = 1,
    Stream = 2,
    Component = 3,
    PropertyPackage = 4,
    ReactionSet = 5,
    Reaction = 6,
}

export class FlowsheetParameterModel implements IFlowsheetParameterModel {
    parameter?: string | undefined;
    value?: number;
    unit?: string | undefined;
    displayName?: string | undefined;
    flowsheetObjectUniqueId?: string | undefined;
    accessMode?: FlowsheetParameterAccessMode;

    constructor(data?: IFlowsheetParameterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.displayName = _data["displayName"];
            this.flowsheetObjectUniqueId = _data["flowsheetObjectUniqueId"];
            this.accessMode = _data["accessMode"];
        }
    }

    static fromJS(data: any): FlowsheetParameterModel {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetParameterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["displayName"] = this.displayName;
        data["flowsheetObjectUniqueId"] = this.flowsheetObjectUniqueId;
        data["accessMode"] = this.accessMode;
        return data;
    }
}

export interface IFlowsheetParameterModel {
    parameter?: string | undefined;
    value?: number;
    unit?: string | undefined;
    displayName?: string | undefined;
    flowsheetObjectUniqueId?: string | undefined;
    accessMode?: FlowsheetParameterAccessMode;
}

export enum FlowsheetParameterAccessMode {
    ReadWrite = 0,
    ReadOnly = 1,
    WriteOnly = 2,
}

export class IsFlowsheetAnalyzedResponseModel implements IIsFlowsheetAnalyzedResponseModel {
    isAnalyzed?: boolean;

    constructor(data?: IIsFlowsheetAnalyzedResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAnalyzed = _data["isAnalyzed"];
        }
    }

    static fromJS(data: any): IsFlowsheetAnalyzedResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new IsFlowsheetAnalyzedResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAnalyzed"] = this.isAnalyzed;
        return data;
    }
}

export interface IIsFlowsheetAnalyzedResponseModel {
    isAnalyzed?: boolean;
}

export class JobActionResponseModel implements IJobActionResponseModel {
    id?: number;
    jobId?: number;
    triggerOn?: JobActionTriggerOn;
    customConditionFunction?: string | undefined;
    type?: JobActionType;

    constructor(data?: IJobActionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobId = _data["jobId"];
            this.triggerOn = _data["triggerOn"];
            this.customConditionFunction = _data["customConditionFunction"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): JobActionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobActionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobId"] = this.jobId;
        data["triggerOn"] = this.triggerOn;
        data["customConditionFunction"] = this.customConditionFunction;
        data["type"] = this.type;
        return data;
    }
}

export interface IJobActionResponseModel {
    id?: number;
    jobId?: number;
    triggerOn?: JobActionTriggerOn;
    customConditionFunction?: string | undefined;
    type?: JobActionType;
}

export class WebHookActionResponseModel implements IWebHookActionResponseModel {
    id?: number;
    actionId?: number;
    endpoint?: string | undefined;
    httpMethod?: WebHookActionHttpMethod;
    payloadType?: WebHookActionPayloadType;
    body?: string | undefined;
    headers?: WebHookActionHeaderResponseModel[] | undefined;
    formParameters?: WebHookActionFormParameterResponseModel[] | undefined;

    constructor(data?: IWebHookActionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionId = _data["actionId"];
            this.endpoint = _data["endpoint"];
            this.httpMethod = _data["httpMethod"];
            this.payloadType = _data["payloadType"];
            this.body = _data["body"];
            if (Array.isArray(_data["headers"])) {
                this.headers = [] as any;
                for (let item of _data["headers"])
                    this.headers!.push(WebHookActionHeaderResponseModel.fromJS(item));
            }
            if (Array.isArray(_data["formParameters"])) {
                this.formParameters = [] as any;
                for (let item of _data["formParameters"])
                    this.formParameters!.push(WebHookActionFormParameterResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WebHookActionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookActionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionId"] = this.actionId;
        data["endpoint"] = this.endpoint;
        data["httpMethod"] = this.httpMethod;
        data["payloadType"] = this.payloadType;
        data["body"] = this.body;
        if (Array.isArray(this.headers)) {
            data["headers"] = [];
            for (let item of this.headers)
                data["headers"].push(item.toJSON());
        }
        if (Array.isArray(this.formParameters)) {
            data["formParameters"] = [];
            for (let item of this.formParameters)
                data["formParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWebHookActionResponseModel {
    id?: number;
    actionId?: number;
    endpoint?: string | undefined;
    httpMethod?: WebHookActionHttpMethod;
    payloadType?: WebHookActionPayloadType;
    body?: string | undefined;
    headers?: WebHookActionHeaderResponseModel[] | undefined;
    formParameters?: WebHookActionFormParameterResponseModel[] | undefined;
}

export class WebHookActionHeaderResponseModel implements IWebHookActionHeaderResponseModel {
    id?: number;
    webHookId?: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IWebHookActionHeaderResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webHookId = _data["webHookId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): WebHookActionHeaderResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookActionHeaderResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webHookId"] = this.webHookId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IWebHookActionHeaderResponseModel {
    id?: number;
    webHookId?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export class WebHookActionFormParameterResponseModel implements IWebHookActionFormParameterResponseModel {
    id?: number;
    webHookId?: number;
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IWebHookActionFormParameterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.webHookId = _data["webHookId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): WebHookActionFormParameterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebHookActionFormParameterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["webHookId"] = this.webHookId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IWebHookActionFormParameterResponseModel {
    id?: number;
    webHookId?: number;
    name?: string | undefined;
    value?: string | undefined;
}

export class EmailActionResponseModel implements IEmailActionResponseModel {
    id?: number;
    actionId?: number;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    isHtml?: boolean;

    constructor(data?: IEmailActionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actionId = _data["actionId"];
            this.to = _data["to"];
            this.from = _data["from"];
            this.subject = _data["subject"];
            this.message = _data["message"];
            this.isHtml = _data["isHtml"];
        }
    }

    static fromJS(data: any): EmailActionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailActionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actionId"] = this.actionId;
        data["to"] = this.to;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["message"] = this.message;
        data["isHtml"] = this.isHtml;
        return data;
    }
}

export interface IEmailActionResponseModel {
    id?: number;
    actionId?: number;
    to?: string | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
    isHtml?: boolean;
}

export class JobResponseModel implements IJobResponseModel {
    id?: number;
    applicationId?: number | undefined;
    application?: string | undefined;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
    adUserId?: string;
    owner?: OwnerModel | undefined;
    jobType?: JobType;
    createdAt?: Date;
    processingStatus?: JobProcessingStatus;
    simulatorType?: SimulatorType;
    inputParameters?: JobInputParameterResponseModel[] | undefined;
    executions?: JobExecutionResponseModel[] | undefined;

    constructor(data?: IJobResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationId = _data["applicationId"];
            this.application = _data["application"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.flowsheetItemId = _data["flowsheetItemId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
            this.adUserId = _data["adUserId"];
            this.owner = _data["owner"] ? OwnerModel.fromJS(_data["owner"]) : <any>undefined;
            this.jobType = _data["jobType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.processingStatus = _data["processingStatus"];
            this.simulatorType = _data["simulatorType"];
            if (Array.isArray(_data["inputParameters"])) {
                this.inputParameters = [] as any;
                for (let item of _data["inputParameters"])
                    this.inputParameters!.push(JobInputParameterResponseModel.fromJS(item));
            }
            if (Array.isArray(_data["executions"])) {
                this.executions = [] as any;
                for (let item of _data["executions"])
                    this.executions!.push(JobExecutionResponseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationId"] = this.applicationId;
        data["application"] = this.application;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["flowsheetItemId"] = this.flowsheetItemId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        data["adUserId"] = this.adUserId;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["jobType"] = this.jobType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["processingStatus"] = this.processingStatus;
        data["simulatorType"] = this.simulatorType;
        if (Array.isArray(this.inputParameters)) {
            data["inputParameters"] = [];
            for (let item of this.inputParameters)
                data["inputParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.executions)) {
            data["executions"] = [];
            for (let item of this.executions)
                data["executions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobResponseModel {
    id?: number;
    applicationId?: number | undefined;
    application?: string | undefined;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
    adUserId?: string;
    owner?: OwnerModel | undefined;
    jobType?: JobType;
    createdAt?: Date;
    processingStatus?: JobProcessingStatus;
    simulatorType?: SimulatorType;
    inputParameters?: JobInputParameterResponseModel[] | undefined;
    executions?: JobExecutionResponseModel[] | undefined;
}

export class JobInputParameterResponseModel implements IJobInputParameterResponseModel {
    id?: number;
    parameter?: string | undefined;
    value?: number;

    constructor(data?: IJobInputParameterResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JobInputParameterResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobInputParameterResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IJobInputParameterResponseModel {
    id?: number;
    parameter?: string | undefined;
    value?: number;
}

export class JobExecutionResponseModel implements IJobExecutionResponseModel {
    id?: number;
    status?: JobExecutionStatus;
    assignedToAgentId?: number | undefined;
    assignedToAgent?: string | undefined;
    errorsMessage?: string | undefined;
    totalProcessingDuration?: string | undefined;
    successfullCount?: number;
    failedCount?: number;
    totalCount?: number;
    savedFilename?: string | undefined;
    forceCalculatedFlowsheetUpload?: boolean | undefined;
    agentVersion?: string | undefined;
    simulatorVersion?: string | undefined;

    constructor(data?: IJobExecutionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.assignedToAgentId = _data["assignedToAgentId"];
            this.assignedToAgent = _data["assignedToAgent"];
            this.errorsMessage = _data["errorsMessage"];
            this.totalProcessingDuration = _data["totalProcessingDuration"];
            this.successfullCount = _data["successfullCount"];
            this.failedCount = _data["failedCount"];
            this.totalCount = _data["totalCount"];
            this.savedFilename = _data["savedFilename"];
            this.forceCalculatedFlowsheetUpload = _data["forceCalculatedFlowsheetUpload"];
            this.agentVersion = _data["agentVersion"];
            this.simulatorVersion = _data["simulatorVersion"];
        }
    }

    static fromJS(data: any): JobExecutionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobExecutionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["assignedToAgentId"] = this.assignedToAgentId;
        data["assignedToAgent"] = this.assignedToAgent;
        data["errorsMessage"] = this.errorsMessage;
        data["totalProcessingDuration"] = this.totalProcessingDuration;
        data["successfullCount"] = this.successfullCount;
        data["failedCount"] = this.failedCount;
        data["totalCount"] = this.totalCount;
        data["savedFilename"] = this.savedFilename;
        data["forceCalculatedFlowsheetUpload"] = this.forceCalculatedFlowsheetUpload;
        data["agentVersion"] = this.agentVersion;
        data["simulatorVersion"] = this.simulatorVersion;
        return data;
    }
}

export interface IJobExecutionResponseModel {
    id?: number;
    status?: JobExecutionStatus;
    assignedToAgentId?: number | undefined;
    assignedToAgent?: string | undefined;
    errorsMessage?: string | undefined;
    totalProcessingDuration?: string | undefined;
    successfullCount?: number;
    failedCount?: number;
    totalCount?: number;
    savedFilename?: string | undefined;
    forceCalculatedFlowsheetUpload?: boolean | undefined;
    agentVersion?: string | undefined;
    simulatorVersion?: string | undefined;
}

export class PagedListResponseModelOfJobExecutionResponseModel implements IPagedListResponseModelOfJobExecutionResponseModel {
    items?: JobExecutionResponseModel[] | undefined;
    totalRecords?: number;

    constructor(data?: IPagedListResponseModelOfJobExecutionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobExecutionResponseModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): PagedListResponseModelOfJobExecutionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListResponseModelOfJobExecutionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IPagedListResponseModelOfJobExecutionResponseModel {
    items?: JobExecutionResponseModel[] | undefined;
    totalRecords?: number;
}

export class JobExecutionResultResponseModel implements IJobExecutionResultResponseModel {
    id?: number;
    parameter?: string | undefined;
    value?: number;

    constructor(data?: IJobExecutionResultResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parameter = _data["parameter"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): JobExecutionResultResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobExecutionResultResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        return data;
    }
}

export interface IJobExecutionResultResponseModel {
    id?: number;
    parameter?: string | undefined;
    value?: number;
}

export class JobExecutionActionResponseModel implements IJobExecutionActionResponseModel {
    jobExecutionId?: number;
    actionId?: number;
    action?: JobActionResponseModel | undefined;
    status?: JobExecutionActionStatus;
    noOfAttempts?: number;
    maxRetries?: number;
    lastUpdateAt?: Date;

    constructor(data?: IJobExecutionActionResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobExecutionId = _data["jobExecutionId"];
            this.actionId = _data["actionId"];
            this.action = _data["action"] ? JobActionResponseModel.fromJS(_data["action"]) : <any>undefined;
            this.status = _data["status"];
            this.noOfAttempts = _data["noOfAttempts"];
            this.maxRetries = _data["maxRetries"];
            this.lastUpdateAt = _data["lastUpdateAt"] ? new Date(_data["lastUpdateAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobExecutionActionResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobExecutionActionResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobExecutionId"] = this.jobExecutionId;
        data["actionId"] = this.actionId;
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["noOfAttempts"] = this.noOfAttempts;
        data["maxRetries"] = this.maxRetries;
        data["lastUpdateAt"] = this.lastUpdateAt ? this.lastUpdateAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobExecutionActionResponseModel {
    jobExecutionId?: number;
    actionId?: number;
    action?: JobActionResponseModel | undefined;
    status?: JobExecutionActionStatus;
    noOfAttempts?: number;
    maxRetries?: number;
    lastUpdateAt?: Date;
}

export enum JobExecutionActionStatus {
    NotExecuted = 0,
    SuccessfullyExecuted = 1,
    Failed = 2,
}

export class PagedListResponseModelOfJobSearchResponseModel implements IPagedListResponseModelOfJobSearchResponseModel {
    items?: JobSearchResponseModel[] | undefined;
    totalRecords?: number;

    constructor(data?: IPagedListResponseModelOfJobSearchResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobSearchResponseModel.fromJS(item));
            }
            this.totalRecords = _data["totalRecords"];
        }
    }

    static fromJS(data: any): PagedListResponseModelOfJobSearchResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedListResponseModelOfJobSearchResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalRecords"] = this.totalRecords;
        return data;
    }
}

export interface IPagedListResponseModelOfJobSearchResponseModel {
    items?: JobSearchResponseModel[] | undefined;
    totalRecords?: number;
}

export class JobSearchResponseModel implements IJobSearchResponseModel {
    id?: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
    flowsheetFromJobId?: number | undefined;
    jobType?: JobType;
    simulatorType?: SimulatorType;
    createdAt?: Date;
    adUserId?: string | undefined;
    processingStatus?: JobProcessingStatus;
    applicationId?: number | undefined;
    applicationName?: string | undefined;
    agentId?: number | undefined;
    agentName?: string | undefined;
    agentVersion?: string | undefined;
    calculationDuration?: string | undefined;

    constructor(data?: IJobSearchResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.flowsheetDriveId = _data["flowsheetDriveId"];
            this.flowsheetItemId = _data["flowsheetItemId"];
            this.flowsheetVersion = _data["flowsheetVersion"];
            this.flowsheetFromJobId = _data["flowsheetFromJobId"];
            this.jobType = _data["jobType"];
            this.simulatorType = _data["simulatorType"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.adUserId = _data["adUserId"];
            this.processingStatus = _data["processingStatus"];
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.agentId = _data["agentId"];
            this.agentName = _data["agentName"];
            this.agentVersion = _data["agentVersion"];
            this.calculationDuration = _data["calculationDuration"];
        }
    }

    static fromJS(data: any): JobSearchResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["flowsheetDriveId"] = this.flowsheetDriveId;
        data["flowsheetItemId"] = this.flowsheetItemId;
        data["flowsheetVersion"] = this.flowsheetVersion;
        data["flowsheetFromJobId"] = this.flowsheetFromJobId;
        data["jobType"] = this.jobType;
        data["simulatorType"] = this.simulatorType;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["adUserId"] = this.adUserId;
        data["processingStatus"] = this.processingStatus;
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["agentId"] = this.agentId;
        data["agentName"] = this.agentName;
        data["agentVersion"] = this.agentVersion;
        data["calculationDuration"] = this.calculationDuration;
        return data;
    }
}

export interface IJobSearchResponseModel {
    id?: number;
    flowsheetDriveId?: string | undefined;
    flowsheetItemId?: string | undefined;
    flowsheetVersion?: string | undefined;
    flowsheetFromJobId?: number | undefined;
    jobType?: JobType;
    simulatorType?: SimulatorType;
    createdAt?: Date;
    adUserId?: string | undefined;
    processingStatus?: JobProcessingStatus;
    applicationId?: number | undefined;
    applicationName?: string | undefined;
    agentId?: number | undefined;
    agentName?: string | undefined;
    agentVersion?: string | undefined;
    calculationDuration?: string | undefined;
}

export class PaginationQuery implements IPaginationQuery {
    skip?: number;
    take?: number;

    constructor(data?: IPaginationQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.skip = _data["skip"];
            this.take = _data["take"];
        }
    }

    static fromJS(data: any): PaginationQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PaginationQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["skip"] = this.skip;
        data["take"] = this.take;
        return data;
    }
}

export interface IPaginationQuery {
    skip?: number;
    take?: number;
}

export class UserJobsQuery extends PaginationQuery implements IUserJobsQuery {
    jobId?: number | undefined;
    jobType?: JobType | undefined;
    simulatorType?: SimulatorType | undefined;
    processingStatus?: JobProcessingStatus | undefined;
    applicationId?: number | undefined;
    agentId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;

    constructor(data?: IUserJobsQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobType = _data["jobType"];
            this.simulatorType = _data["simulatorType"];
            this.processingStatus = _data["processingStatus"];
            this.applicationId = _data["applicationId"];
            this.agentId = _data["agentId"];
            this.dateFrom = _data["dateFrom"] ? new Date(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? new Date(_data["dateTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserJobsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new UserJobsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobType"] = this.jobType;
        data["simulatorType"] = this.simulatorType;
        data["processingStatus"] = this.processingStatus;
        data["applicationId"] = this.applicationId;
        data["agentId"] = this.agentId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserJobsQuery extends IPaginationQuery {
    jobId?: number | undefined;
    jobType?: JobType | undefined;
    simulatorType?: SimulatorType | undefined;
    processingStatus?: JobProcessingStatus | undefined;
    applicationId?: number | undefined;
    agentId?: number | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
}

export class ReindexingRunModel implements IReindexingRunModel {
    uniqueId?: string;
    type?: string | undefined;
    batchSize?: number;
    totalItemsCount?: number;
    startedAt?: Date;
    status?: RunningStatus;
    message?: string | undefined;
    lastProcessedId?: number | undefined;
    processedItemsCount?: number;
    processedPercentage?: number | undefined;
    overallAverageDurationPerIteration?: number;
    sqlAverageDurationPerIteration?: number;
    indexAverageDurationPerIteration?: number;
    timeLeft?: string;
    timeLeftStr?: string | undefined;
    runs?: RunModel[] | undefined;

    constructor(data?: IReindexingRunModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueId = _data["uniqueId"];
            this.type = _data["type"];
            this.batchSize = _data["batchSize"];
            this.totalItemsCount = _data["totalItemsCount"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.message = _data["message"];
            this.lastProcessedId = _data["lastProcessedId"];
            this.processedItemsCount = _data["processedItemsCount"];
            this.processedPercentage = _data["processedPercentage"];
            this.overallAverageDurationPerIteration = _data["overallAverageDurationPerIteration"];
            this.sqlAverageDurationPerIteration = _data["sqlAverageDurationPerIteration"];
            this.indexAverageDurationPerIteration = _data["indexAverageDurationPerIteration"];
            this.timeLeft = _data["timeLeft"];
            this.timeLeftStr = _data["timeLeftStr"];
            if (Array.isArray(_data["runs"])) {
                this.runs = [] as any;
                for (let item of _data["runs"])
                    this.runs!.push(RunModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReindexingRunModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReindexingRunModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueId"] = this.uniqueId;
        data["type"] = this.type;
        data["batchSize"] = this.batchSize;
        data["totalItemsCount"] = this.totalItemsCount;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["message"] = this.message;
        data["lastProcessedId"] = this.lastProcessedId;
        data["processedItemsCount"] = this.processedItemsCount;
        data["processedPercentage"] = this.processedPercentage;
        data["overallAverageDurationPerIteration"] = this.overallAverageDurationPerIteration;
        data["sqlAverageDurationPerIteration"] = this.sqlAverageDurationPerIteration;
        data["indexAverageDurationPerIteration"] = this.indexAverageDurationPerIteration;
        data["timeLeft"] = this.timeLeft;
        data["timeLeftStr"] = this.timeLeftStr;
        if (Array.isArray(this.runs)) {
            data["runs"] = [];
            for (let item of this.runs)
                data["runs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReindexingRunModel {
    uniqueId?: string;
    type?: string | undefined;
    batchSize?: number;
    totalItemsCount?: number;
    startedAt?: Date;
    status?: RunningStatus;
    message?: string | undefined;
    lastProcessedId?: number | undefined;
    processedItemsCount?: number;
    processedPercentage?: number | undefined;
    overallAverageDurationPerIteration?: number;
    sqlAverageDurationPerIteration?: number;
    indexAverageDurationPerIteration?: number;
    timeLeft?: string;
    timeLeftStr?: string | undefined;
    runs?: RunModel[] | undefined;
}

export enum RunningStatus {
    Running = 0,
    Finished = 1,
    Failed = 2,
}

export class RunModel implements IRunModel {
    processedItemsCount?: number;
    sqlDuration?: string;
    indexDuration?: string;
    overallDuration?: string;

    constructor(data?: IRunModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processedItemsCount = _data["processedItemsCount"];
            this.sqlDuration = _data["sqlDuration"];
            this.indexDuration = _data["indexDuration"];
            this.overallDuration = _data["overallDuration"];
        }
    }

    static fromJS(data: any): RunModel {
        data = typeof data === 'object' ? data : {};
        let result = new RunModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processedItemsCount"] = this.processedItemsCount;
        data["sqlDuration"] = this.sqlDuration;
        data["indexDuration"] = this.indexDuration;
        data["overallDuration"] = this.overallDuration;
        return data;
    }
}

export interface IRunModel {
    processedItemsCount?: number;
    sqlDuration?: string;
    indexDuration?: string;
    overallDuration?: string;
}

export class SharedWithResponseModel implements ISharedWithResponseModel {
    id?: number;
    name?: string | undefined;
    userPrincipalName?: string | undefined;
    destinationId?: string | undefined;
    destinationType?: SharedWithDestinationType;

    constructor(data?: ISharedWithResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.userPrincipalName = _data["userPrincipalName"];
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
        }
    }

    static fromJS(data: any): SharedWithResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharedWithResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["userPrincipalName"] = this.userPrincipalName;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        return data;
    }
}

export interface ISharedWithResponseModel {
    id?: number;
    name?: string | undefined;
    userPrincipalName?: string | undefined;
    destinationId?: string | undefined;
    destinationType?: SharedWithDestinationType;
}

export enum SharedWithDestinationType {
    User = 0,
    Group = 1,
    EveryonePublic = 2,
}

export class ShareWithPostModel implements IShareWithPostModel {
    destinationId?: string | undefined;
    destinationType!: SharedWithDestinationType;

    constructor(data?: IShareWithPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
        }
    }

    static fromJS(data: any): ShareWithPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareWithPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        return data;
    }
}

export interface IShareWithPostModel {
    destinationId?: string | undefined;
    destinationType: SharedWithDestinationType;
}

export class StopSharingPostModel implements IStopSharingPostModel {
    destinationId?: string | undefined;
    destinationType!: SharedWithDestinationType;

    constructor(data?: IStopSharingPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
        }
    }

    static fromJS(data: any): StopSharingPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopSharingPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        return data;
    }
}

export interface IStopSharingPostModel {
    destinationId?: string | undefined;
    destinationType: SharedWithDestinationType;
}

export class AggregatedUsegDataResponseModel implements IAggregatedUsegDataResponseModel {
    totalCount?: CountsModel | undefined;
    avgCalcDuration?: AverageDurationModel | undefined;
    avgSetupAndCalcDuration?: AverageDurationModel | undefined;
    calculationRuntime?: RuntimeModel | undefined;
    setupAndCalculationRuntime?: RuntimeModel | undefined;

    constructor(data?: IAggregatedUsegDataResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"] ? CountsModel.fromJS(_data["totalCount"]) : <any>undefined;
            this.avgCalcDuration = _data["avgCalcDuration"] ? AverageDurationModel.fromJS(_data["avgCalcDuration"]) : <any>undefined;
            this.avgSetupAndCalcDuration = _data["avgSetupAndCalcDuration"] ? AverageDurationModel.fromJS(_data["avgSetupAndCalcDuration"]) : <any>undefined;
            this.calculationRuntime = _data["calculationRuntime"] ? RuntimeModel.fromJS(_data["calculationRuntime"]) : <any>undefined;
            this.setupAndCalculationRuntime = _data["setupAndCalculationRuntime"] ? RuntimeModel.fromJS(_data["setupAndCalculationRuntime"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AggregatedUsegDataResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedUsegDataResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount ? this.totalCount.toJSON() : <any>undefined;
        data["avgCalcDuration"] = this.avgCalcDuration ? this.avgCalcDuration.toJSON() : <any>undefined;
        data["avgSetupAndCalcDuration"] = this.avgSetupAndCalcDuration ? this.avgSetupAndCalcDuration.toJSON() : <any>undefined;
        data["calculationRuntime"] = this.calculationRuntime ? this.calculationRuntime.toJSON() : <any>undefined;
        data["setupAndCalculationRuntime"] = this.setupAndCalculationRuntime ? this.setupAndCalculationRuntime.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAggregatedUsegDataResponseModel {
    totalCount?: CountsModel | undefined;
    avgCalcDuration?: AverageDurationModel | undefined;
    avgSetupAndCalcDuration?: AverageDurationModel | undefined;
    calculationRuntime?: RuntimeModel | undefined;
    setupAndCalculationRuntime?: RuntimeModel | undefined;
}

export class CountsModel implements ICountsModel {
    totalJobs?: number;
    totalExecutions?: number;
    calculatedExecutions?: number;
    failedExecutions?: number;

    constructor(data?: ICountsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalJobs = _data["totalJobs"];
            this.totalExecutions = _data["totalExecutions"];
            this.calculatedExecutions = _data["calculatedExecutions"];
            this.failedExecutions = _data["failedExecutions"];
        }
    }

    static fromJS(data: any): CountsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalJobs"] = this.totalJobs;
        data["totalExecutions"] = this.totalExecutions;
        data["calculatedExecutions"] = this.calculatedExecutions;
        data["failedExecutions"] = this.failedExecutions;
        return data;
    }
}

export interface ICountsModel {
    totalJobs?: number;
    totalExecutions?: number;
    calculatedExecutions?: number;
    failedExecutions?: number;
}

export class AverageDurationModel implements IAverageDurationModel {
    overall?: number;
    calculatedExecutions?: number;
    failedExecutions?: number;

    constructor(data?: IAverageDurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overall = _data["overall"];
            this.calculatedExecutions = _data["calculatedExecutions"];
            this.failedExecutions = _data["failedExecutions"];
        }
    }

    static fromJS(data: any): AverageDurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AverageDurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overall"] = this.overall;
        data["calculatedExecutions"] = this.calculatedExecutions;
        data["failedExecutions"] = this.failedExecutions;
        return data;
    }
}

export interface IAverageDurationModel {
    overall?: number;
    calculatedExecutions?: number;
    failedExecutions?: number;
}

export class RuntimeModel implements IRuntimeModel {
    overall?: number;
    calculatedExecutions?: number;
    failedExecutions?: number;

    constructor(data?: IRuntimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overall = _data["overall"];
            this.calculatedExecutions = _data["calculatedExecutions"];
            this.failedExecutions = _data["failedExecutions"];
        }
    }

    static fromJS(data: any): RuntimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overall"] = this.overall;
        data["calculatedExecutions"] = this.calculatedExecutions;
        data["failedExecutions"] = this.failedExecutions;
        return data;
    }
}

export interface IRuntimeModel {
    overall?: number;
    calculatedExecutions?: number;
    failedExecutions?: number;
}

export class UserGroupResponseModel implements IUserGroupResponseModel {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUserGroupResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserGroupResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserGroupResponseModel {
    id?: string | undefined;
    name?: string | undefined;
}

export class ActiveApiKeyResponseModel implements IActiveApiKeyResponseModel {
    apiKey?: string;

    constructor(data?: IActiveApiKeyResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiKey = _data["apiKey"];
        }
    }

    static fromJS(data: any): ActiveApiKeyResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveApiKeyResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiKey"] = this.apiKey;
        return data;
    }
}

export interface IActiveApiKeyResponseModel {
    apiKey?: string;
}

export class ExternalClientResultResponseModel implements IExternalClientResultResponseModel {
    processingStatus?: JobProcessingStatus;
    error?: string | undefined;
    outputParameters?: ParamterResultModel[] | undefined;

    constructor(data?: IExternalClientResultResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingStatus = _data["processingStatus"];
            this.error = _data["error"];
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(ParamterResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalClientResultResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalClientResultResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingStatus"] = this.processingStatus;
        data["error"] = this.error;
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalClientResultResponseModel {
    processingStatus?: JobProcessingStatus;
    error?: string | undefined;
    outputParameters?: ParamterResultModel[] | undefined;
}

export class ParamterResultModel implements IParamterResultModel {
    parameter?: string | undefined;
    alias?: string | undefined;
    value?: number;
    unit?: string | undefined;

    constructor(data?: IParamterResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.alias = _data["alias"];
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): ParamterResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParamterResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["alias"] = this.alias;
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}

export interface IParamterResultModel {
    parameter?: string | undefined;
    alias?: string | undefined;
    value?: number;
    unit?: string | undefined;
}

export class AnalyzedFlowsheetPostModel implements IAnalyzedFlowsheetPostModel {
    activeJobId?: string | undefined;
    agentId?: number;
    totalProcessingDuration?: string | undefined;
    isDynamic!: boolean;
    flowsheetObjects!: FlowsheetObjectModel2[];
    flowsheetParameters!: FlowsheetParameter[];

    constructor(data?: IAnalyzedFlowsheetPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.flowsheetObjects = [];
            this.flowsheetParameters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeJobId = _data["activeJobId"];
            this.agentId = _data["agentId"];
            this.totalProcessingDuration = _data["totalProcessingDuration"];
            this.isDynamic = _data["isDynamic"];
            if (Array.isArray(_data["flowsheetObjects"])) {
                this.flowsheetObjects = [] as any;
                for (let item of _data["flowsheetObjects"])
                    this.flowsheetObjects!.push(FlowsheetObjectModel2.fromJS(item));
            }
            if (Array.isArray(_data["flowsheetParameters"])) {
                this.flowsheetParameters = [] as any;
                for (let item of _data["flowsheetParameters"])
                    this.flowsheetParameters!.push(FlowsheetParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AnalyzedFlowsheetPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzedFlowsheetPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeJobId"] = this.activeJobId;
        data["agentId"] = this.agentId;
        data["totalProcessingDuration"] = this.totalProcessingDuration;
        data["isDynamic"] = this.isDynamic;
        if (Array.isArray(this.flowsheetObjects)) {
            data["flowsheetObjects"] = [];
            for (let item of this.flowsheetObjects)
                data["flowsheetObjects"].push(item.toJSON());
        }
        if (Array.isArray(this.flowsheetParameters)) {
            data["flowsheetParameters"] = [];
            for (let item of this.flowsheetParameters)
                data["flowsheetParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAnalyzedFlowsheetPostModel {
    activeJobId?: string | undefined;
    agentId?: number;
    totalProcessingDuration?: string | undefined;
    isDynamic: boolean;
    flowsheetObjects: FlowsheetObjectModel2[];
    flowsheetParameters: FlowsheetParameter[];
}

export class FlowsheetObjectModel2 implements IFlowsheetObjectModel2 {
    uniqueIdentifier!: string;
    displayName?: string | undefined;
    objectType!: FlowsheetObjectType;
    subtype?: string | undefined;
    casNumber?: string | undefined;

    constructor(data?: IFlowsheetObjectModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueIdentifier = _data["uniqueIdentifier"];
            this.displayName = _data["displayName"];
            this.objectType = _data["objectType"];
            this.subtype = _data["subtype"];
            this.casNumber = _data["casNumber"];
        }
    }

    static fromJS(data: any): FlowsheetObjectModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetObjectModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueIdentifier"] = this.uniqueIdentifier;
        data["displayName"] = this.displayName;
        data["objectType"] = this.objectType;
        data["subtype"] = this.subtype;
        data["casNumber"] = this.casNumber;
        return data;
    }
}

export interface IFlowsheetObjectModel2 {
    uniqueIdentifier: string;
    displayName?: string | undefined;
    objectType: FlowsheetObjectType;
    subtype?: string | undefined;
    casNumber?: string | undefined;
}

export class FlowsheetParameter implements IFlowsheetParameter {
    uniqueFlowseetObjectId!: string;
    parameter!: string;
    value!: number;
    unit?: string | undefined;
    displayName!: string;
    accessMode?: FlowsheetParameterAccessMode | undefined;

    constructor(data?: IFlowsheetParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueFlowseetObjectId = _data["uniqueFlowseetObjectId"];
            this.parameter = _data["parameter"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.displayName = _data["displayName"];
            this.accessMode = _data["accessMode"];
        }
    }

    static fromJS(data: any): FlowsheetParameter {
        data = typeof data === 'object' ? data : {};
        let result = new FlowsheetParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueFlowseetObjectId"] = this.uniqueFlowseetObjectId;
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["displayName"] = this.displayName;
        data["accessMode"] = this.accessMode;
        return data;
    }
}

export interface IFlowsheetParameter {
    uniqueFlowseetObjectId: string;
    parameter: string;
    value: number;
    unit?: string | undefined;
    displayName: string;
    accessMode?: FlowsheetParameterAccessMode | undefined;
}

export class CalcualtedFlowsheetPostModel implements ICalcualtedFlowsheetPostModel {
    calculationDuration?: string | undefined;
    totalProcessingDuration?: string | undefined;
    outputParameters?: OutputParameterModel3[] | undefined;

    constructor(data?: ICalcualtedFlowsheetPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationDuration = _data["calculationDuration"];
            this.totalProcessingDuration = _data["totalProcessingDuration"];
            if (Array.isArray(_data["outputParameters"])) {
                this.outputParameters = [] as any;
                for (let item of _data["outputParameters"])
                    this.outputParameters!.push(OutputParameterModel3.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalcualtedFlowsheetPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CalcualtedFlowsheetPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationDuration"] = this.calculationDuration;
        data["totalProcessingDuration"] = this.totalProcessingDuration;
        if (Array.isArray(this.outputParameters)) {
            data["outputParameters"] = [];
            for (let item of this.outputParameters)
                data["outputParameters"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalcualtedFlowsheetPostModel {
    calculationDuration?: string | undefined;
    totalProcessingDuration?: string | undefined;
    outputParameters?: OutputParameterModel3[] | undefined;
}

export class OutputParameterModel3 implements IOutputParameterModel3 {
    parameter!: string;
    value!: number;
    unit?: string | undefined;
    flowsheetObjectUniqueId!: string;

    constructor(data?: IOutputParameterModel3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"];
            this.value = _data["value"];
            this.unit = _data["unit"];
            this.flowsheetObjectUniqueId = _data["flowsheetObjectUniqueId"];
        }
    }

    static fromJS(data: any): OutputParameterModel3 {
        data = typeof data === 'object' ? data : {};
        let result = new OutputParameterModel3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter;
        data["value"] = this.value;
        data["unit"] = this.unit;
        data["flowsheetObjectUniqueId"] = this.flowsheetObjectUniqueId;
        return data;
    }
}

export interface IOutputParameterModel3 {
    parameter: string;
    value: number;
    unit?: string | undefined;
    flowsheetObjectUniqueId: string;
}

export class FailedJobPostModel implements IFailedJobPostModel {
    calculationDuration?: string | undefined;
    totalProcessingDuration?: string | undefined;
    isCalculationError!: boolean;
    errorMessage!: string;

    constructor(data?: IFailedJobPostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationDuration = _data["calculationDuration"];
            this.totalProcessingDuration = _data["totalProcessingDuration"];
            this.isCalculationError = _data["isCalculationError"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): FailedJobPostModel {
        data = typeof data === 'object' ? data : {};
        let result = new FailedJobPostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationDuration"] = this.calculationDuration;
        data["totalProcessingDuration"] = this.totalProcessingDuration;
        data["isCalculationError"] = this.isCalculationError;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IFailedJobPostModel {
    calculationDuration?: string | undefined;
    totalProcessingDuration?: string | undefined;
    isCalculationError: boolean;
    errorMessage: string;
}

export class Chemcad7SettingsModel implements IChemcad7SettingsModel {
    licensingServers?: LicensingServerModel[] | undefined;

    constructor(data?: IChemcad7SettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["licensingServers"])) {
                this.licensingServers = [] as any;
                for (let item of _data["licensingServers"])
                    this.licensingServers!.push(LicensingServerModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Chemcad7SettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new Chemcad7SettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.licensingServers)) {
            data["licensingServers"] = [];
            for (let item of this.licensingServers)
                data["licensingServers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChemcad7SettingsModel {
    licensingServers?: LicensingServerModel[] | undefined;
}

export class LicensingServerModel implements ILicensingServerModel {
    address?: string | undefined;
    serverType?: CCLicensingServerType;

    constructor(data?: ILicensingServerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"];
            this.serverType = _data["serverType"];
        }
    }

    static fromJS(data: any): LicensingServerModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicensingServerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["serverType"] = this.serverType;
        return data;
    }
}

export interface ILicensingServerModel {
    address?: string | undefined;
    serverType?: CCLicensingServerType;
}

export enum CCLicensingServerType {
    LicenseManager = 1,
    SuperPro = 2,
}

export class UserAgentsResponseModel implements IUserAgentsResponseModel {
    userId?: string;
    user?: OwnerModel | undefined;
    uncalculatedJobs?: SimulatorCount | undefined;
    calculatingJobs?: SimulatorCount | undefined;
    availableAgents?: SimulatorCount | undefined;
    personalAgents?: SimulatorCount | undefined;

    constructor(data?: IUserAgentsResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? OwnerModel.fromJS(_data["user"]) : <any>undefined;
            this.uncalculatedJobs = _data["uncalculatedJobs"] ? SimulatorCount.fromJS(_data["uncalculatedJobs"]) : <any>undefined;
            this.calculatingJobs = _data["calculatingJobs"] ? SimulatorCount.fromJS(_data["calculatingJobs"]) : <any>undefined;
            this.availableAgents = _data["availableAgents"] ? SimulatorCount.fromJS(_data["availableAgents"]) : <any>undefined;
            this.personalAgents = _data["personalAgents"] ? SimulatorCount.fromJS(_data["personalAgents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserAgentsResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserAgentsResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["uncalculatedJobs"] = this.uncalculatedJobs ? this.uncalculatedJobs.toJSON() : <any>undefined;
        data["calculatingJobs"] = this.calculatingJobs ? this.calculatingJobs.toJSON() : <any>undefined;
        data["availableAgents"] = this.availableAgents ? this.availableAgents.toJSON() : <any>undefined;
        data["personalAgents"] = this.personalAgents ? this.personalAgents.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserAgentsResponseModel {
    userId?: string;
    user?: OwnerModel | undefined;
    uncalculatedJobs?: SimulatorCount | undefined;
    calculatingJobs?: SimulatorCount | undefined;
    availableAgents?: SimulatorCount | undefined;
    personalAgents?: SimulatorCount | undefined;
}

export class SimulatorCount implements ISimulatorCount {
    cC7?: number;
    cC8?: number;
    dwsim?: number;

    constructor(data?: ISimulatorCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cC7 = _data["cC7"];
            this.cC8 = _data["cC8"];
            this.dwsim = _data["dwsim"];
        }
    }

    static fromJS(data: any): SimulatorCount {
        data = typeof data === 'object' ? data : {};
        let result = new SimulatorCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cC7"] = this.cC7;
        data["cC8"] = this.cC8;
        data["dwsim"] = this.dwsim;
        return data;
    }
}

export interface ISimulatorCount {
    cC7?: number;
    cC8?: number;
    dwsim?: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}